<template>
    <div class="maincontainer">
        <taskform ref="taskform" :ntask="ntask" :workersLoaded="workersLoaded"  :loaded="loaded" :workerItems="workerItems" :customers="customers" v-on:saveTask="saveTaskClicked" v-on:removeTask="removeTask" v-on:cloneTask="cloneTask"/>
        <div id="tasksDeletions" class="modal">
            <div class="modal-content">
                <div class="row">
                       <div class="col offset-s11 s1 modal-close" style="text-align: right;">
                        <i class="material-icons">close</i>
                    </div>
                    <div class="col s12 modal-close">
                        USUNIĘTE ZADANIA
                    </div>
                </div>
                <div class="row">
                 
                    <div class="col s12" v-if="deletedloading"><preloader/></div>
                    <div class="col s12" v-if="!deletedloading">
                          <div v-for="deleted in deletions" v-on:click="selectDeleted(deleted.task)"
                          v-bind:class="{ 
                              intervention: deleted.task.kind == 'intervention',
                              inspection: deleted.task.kind == 'inspection',
                              installation: deleted.task.kind == 'installation',
                              other: deleted.task.kind == 'other'
                          }" style="margin: 5px;">
                             {{deleted.task.kind | nameTaskType}} 
                             <template v-if="deleted.task.place">{{deleted.task.place.name}}</template><br />
                             {{deleted.task.startsAt | formatDateWithHour}} - {{deleted.task.endsAt | formatDateWithHour}} <br />
                             <small>{{deleted.created_at | formatDateWithHour}} {{workersdict[deleted.whodid] ? workersdict[deleted.whodid].name : ""}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer row">
                <div class="col offset-s4 s4">
                  
                </div>
            </div>
        </div>
        <div style="position: fixed;top: 100px; left: 0px;z-index: 101; background-color: white; padding-top: 30px; padding-left: 33px; padding-right: 33px; width: 100%">
            <div class="row">
                <div class="col m3 l4 xl6">
                    <template v-if="mode == 'days'">
                        <span style="font-size: larger;">{{currentDate.format('D MMMM YYYY')}}</span> <span style="text-transform: uppercase; font-weight: bold;">{{currentDate.format('dddd')}}</span>
                    </template>
                    <template v-if="mode == 'week'">
                        <span style="font-size: larger;" v-if="currentDate.clone().startOf('week').isSame(currentDate.clone().endOf('week'), 'month')">
                            {{currentDate.startOf('week').format('D')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                        <span style="font-size: larger;" v-else-if="currentDate.clone().startOf('week').isSame(currentDate.clone().endOf('week'), 'year')">
                            {{currentDate.startOf('week').format('D MMMM')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                        <span style="font-size: larger;" v-else>
                            {{currentDate.startOf('week').format('D MMMM YYYY')}} - {{currentDate.endOf('week').format('D MMMM YYYY')}}</span>
                    </template>
                    <br />
                    <button class="btn btn-add green" v-on:click="addTask()">{{$t('tasks.add_task')}}</button>
                    <button class="btn btn-add green" v-on:click="removedTasks()">
                        <i data-v-6fb8108a="" class="material-icons dp6">delete_sweep</i>
                    </button>
                    <div v-if="mode != 'list'" style="padding-top: 15px; width: 75%;"><selector v-model='typeofs' :items="taskstypes" identifier="typessel"></selector></div>
                </div>
                <div class="col m7 l6 xl4">
                    <button class="btn" v-on:click="setMode('list')" v-bind:class="{ red: mode == 'list', grey: mode != 'list'}">{{$t('tasks.modes.list')}}</button>
                    <button class="btn" v-on:click="setMode('map')" v-bind:class="{ red: mode == 'map', grey: mode != 'map'}" v-if="company_address.customer_id == 13"></button>
                    <button class="btn" v-on:click="setMode('days')" v-bind:class="{ red: mode == 'days', grey: mode != 'days'}">{{$t('tasks.modes.days')}}</button>
                    <button class="btn" v-on:click="setMode('week')" v-bind:class="{ red: mode == 'week', grey: mode != 'week' }">{{$t('tasks.modes.week')}}</button>
                    <button class="btn" v-on:click="setMode('month')" v-bind:class="{ red: mode == 'month', grey: mode != 'month' }">{{$t('tasks.modes.month')}}</button>
                    <br />
                    <br />
                    <button class="btn grey" v-on:click="weekAgo()" v-if="mode == 'week'"><i class="material-icons small cursor-pointer">navigate_before</i> </button>
                    <button class="btn white" v-on:click="thisWeek()" v-if="mode == 'week'">{{$t('tasks.this_week')}}</button>
                    <button class="btn grey" v-on:click="weekLater()" v-if="mode == 'week'"><i class="material-icons small cursor-pointer">navigate_next</i> </button>
                    <button class="btn grey" v-on:click="dayAgo()" v-if="mode == 'days'"><i class="material-icons small cursor-pointer">navigate_before</i> </button>
                    <button class="btn white" v-on:click="today()" v-if="mode == 'days'">{{$t('tasks.today')}}</button>
                    <button class="btn grey" v-on:click="dayLater()" v-if="mode == 'days'"><i class="material-icons small cursor-pointer" >navigate_next</i> </button>
                </div>
                <div class="col s2">
                    <table class="calendartable grey lighten-2">
                        <thead>
                            <tr>
                                <td><a v-on:click="monthAgo()"> <i class="material-icons small cursor-pointer">navigate_before</i> </a></td>
                                <td colspan="5">{{calDate.format('MMMM YYYY')}}</td>
                                <td><a v-on:click="monthLater()">
                                        <i class="material-icons small cursor-pointer">navigate_next</i>
                                    </a></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.monday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.tuesday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.wednesday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.thursday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.friday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.saturday_short')}}</td>
                                <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.sunday_short')}}</td>
                            </tr>
                            <tr v-for="week in weeks">
                                <td v-for="day in week" v-on:click="selectDay(day)" class="cursor-pointer">
                                    <span v-bind:class="{ 'red':  currentDate.isSame(day, 'day'),'grey-text': calDate.isSame(day, 'month') == false }" style="padding: 3px;">{{day.format("D")}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col s4">
                        
                    </div>
                    <div class="col s1"></div>
                </div>
            </div>
        </div>
        <table v-if="mode == 'month'" style="margin-top: 250px;">
            <thead v-if="loaded">
                <tr>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.monday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.tuesday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.wednesday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.thursday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.friday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.saturday')}}</td>
                    <td class="grey-text text-darken-1 daycolumn">{{$t('tasks.sunday')}}</td>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <tr v-for="week in weeks">
                    <td v-for="day in week" v-on:click="selectDay(day)" class='cell' style="vertical-align: baseline;">
                        <div><span v-bind:class="{ 'grey-text': currentDate.isSame(day, 'month') == false }">{{day.format("D")}}</span></div>
                        <div class="tasklist">
                            <div style="width: 2.5em; border-radius: 50%; text-align: center; height: 2.5em;line-height: 2em;" v-bind:class="{ intervention: e.kind == 'intervention', inspection: e.kind == 'inspection', installation: e.kind == 'installation', other: e.kind == 'other' }" v-for="e in listMonthsItems[day.format('DD-MM-YYYY')]"  :key="e.id" v-on:click="showTask(e)">
                                {{initialsById(e.worker_ids)}}
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
        <div v-show="mode == 'map'" class="tasks-map-wrap">
            <button
                type="button"
                class="btn tasks-map-forecast-btn"
                v-on:click="toggleMapForecast()"
                v-bind:class="{ green: mapForecastEnabled, grey: !mapForecastEnabled }"
                title="Prognoza kolorow polaczen"
            >
                Prognoza tras
            </button>
            <div class="tasks-map-search">
                <div class="tasks-map-search-input-wrap">
                    <input
                        v-model="mapSearchQuery"
                        @input="mapSearchInputChanged"
                        @keydown.enter.prevent="mapSearchByEnter"
                        class="tasks-map-search-input"
                        type="text"
                        placeholder="Szukaj adresu..."
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        data-lpignore="true"
                        data-1p-ignore="true"
                        data-bwignore="true"
                    />
                    <button
                        v-if="mapSearchQuery || mapSearchResults.length > 0"
                        type="button"
                        class="tasks-map-search-clear"
                        @click="clearMapSearch"
                        title="Wyczyść"
                    >
                        ×
                    </button>
                </div>
                <div v-if="mapSearchLoading" class="tasks-map-search-loading">Szukam...</div>
                <div v-if="externalGeoUnavailable" class="tasks-map-search-loading tasks-map-search-warning">
                    Wyszukiwanie adresow tymczasowo niedostepne (CORS/offline). Pokazuje dane lokalne.
                </div>
                <div v-if="externalVehiclesUnavailable" class="tasks-map-search-loading tasks-map-search-warning">
                    Podglad pojazdow online niedostepny (CORS/offline).
                </div>
                <div v-if="invalidAddressTasksCount > 0" class="tasks-map-search-loading tasks-map-search-warning">
                    Wykryto podejrzane adresy zadan: {{ invalidAddressTasksCount }} (sprawdz i popraw adres).
                </div>
                <div v-if="placeFieldIssuesCount > 0" class="tasks-map-search-loading tasks-map-search-warning">
                    Zadania z ustawionym miejscem, ale bez poprawnych wspolrzednych: {{ placeFieldIssuesCount }}.
                </div>
                <div v-if="unresolvedTasksCount > 0" class="tasks-map-search-loading tasks-map-search-warning">
                    Nie znaleziono adresow dla {{ unresolvedTasksCount }} zadan. Kliknij znacznik ? na mapie, aby zobaczyc szczegoly.
                </div>
                <div v-if="unresolvedTaskEntries.length > 0" class="tasks-map-unresolved-list">
                    <div class="tasks-map-unresolved-list-header">Brakujace adresy</div>
                    <div v-for="entry in unresolvedTaskEntries" :key="entry.task.id" class="tasks-map-unresolved-item">
                        <div class="tasks-map-unresolved-item-main">
                            <div class="tasks-map-unresolved-item-title">{{ unresolvedTaskAddress(entry) }}</div>
                            <div class="tasks-map-unresolved-item-meta">{{ unresolvedTaskReason(entry) }}</div>
                        </div>
                        <div class="tasks-map-unresolved-item-actions">
                            <button type="button" class="btn tasks-map-unresolved-action" @click="startResolveUnresolvedTask(entry)">Ustaw na mapie</button>
                            <button type="button" class="btn tasks-map-unresolved-action grey" @click="focusUnresolvedTask(entry)">Pokaż</button>
                        </div>
                    </div>
                </div>
                <div v-if="mapSearchResults.length > 0" class="tasks-map-search-results">
                    <div
                        v-for="item in mapSearchResults"
                        :key="item.place_id"
                        class="tasks-map-search-item"
                        @click="selectMapSuggestion(item)"
                    >
                        <div>{{ item.display_name }}</div>
                        <div v-if="Number.isFinite(item._distanceKm)" class="tasks-map-search-distance">{{ formatDistanceKm(item._distanceKm) }}</div>
                        <div v-else class="tasks-map-search-distance">odleglosc: brak</div>
                    </div>
                </div>
            </div>
            <div v-if="mapMarkersLoading" class="tasks-map-loading-overlay">
                <preloader n="4" />
                <div class="tasks-map-loading-text">Wczytywanie markerów...</div>
            </div>
            <div ref="map" class="tasks-map"></div>
        </div>
        <table v-if="mode == 'list'" style="margin-top: 250px;">
            <thead style="background-color: #DADADA; padding: 15px; position: sticky; top: 290px;">
                <tr>
                    <th style="width: 12%;">
                        <p v-on:click="set_order('startsAt')"  class="cursor-pointer">
                            <span>{{$t('tasks.list_headers.date')}} </span>
                            <i class="material-icons dp6" v-if="orderby == 'startsAt' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'startsAt' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <div class="input-field">
                            <select id="tasksTimeRange" v-model="rangeSelected">
                              <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                              <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                              <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                              <option value="currentYear">{{$t('calendar.current_year')}}</option>
                              <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                              <option value="other">{{$t('calendar.other_range')}}</option>
                            </select>
                        </div>
                        <div class="row" v-if="rangeSelected == 'other'">
                          <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px;">
                            <input type="date" v-model="tasksTimeRange.startDate" style="font-size: 12px;" />
                            <button class="waves-effect waves-light btn-large red" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%; font-size: 12px;" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
                          </div>
                          <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px;">
                            <input type="date" v-model="tasksTimeRange.endDate" style="font-size: 12px;" />
                            <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%; font-size: 12px;" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                          </div>
                        </div>
                    </th>
                    <th style="width: 20%;">
                        <p v-on:click="set_order('type_of')"  class="cursor-pointer">
                            <span>{{$t('tasks.list_headers.types')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'type_of' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'type_of' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <selector v-model="selections" :items="items"></selector>
                    </th>
                    <th style="width: 20%; padding-top: 15px;" class="input-field">
                        <p v-on:click="set_order('place_name')"  class="cursor-pointer">
                            <span>{{$t('tasks.list_headers.where')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <input id="taskplacesearch" v-model="place_name" name="" style="width: 100%; margin-top: 4px;" />
                    </th>
                    <th style="width: 20%;">
                        <p v-on:click="set_order('worker_ids')"  class="cursor-pointer">
                            <span>{{$t('tasks.list_headers.worker')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'worker_ids' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'worker_ids' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <selector v-model="selectedWorkers" :items="workerItems" identifier="workers"></selector>
                    </th>
                    <th style="width: 10%;">
                        <p v-on:click="set_order('status')"  class="cursor-pointer">
                            <span>{{$t('tasks.list_headers.status')}}</span>
                            <i class="material-icons dp6" v-if="orderby == 'status' && order == 'desc'">arrow_drop_down</i>
                            <i class="material-icons dp6" v-if="orderby == 'status' && order == 'asc'">arrow_drop_up</i>
                        </p>
                        <selector v-model="statuses" :items="statuslist" identifier="statuses"></selector>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loaded">
                <template v-for="(task, index) in listItems">
                    <tr v-on:click="showTask(task)">
                        <td>{{task.startsAt | formatDateWithHour}} - {{task.endsAt | formatDateWithHour}}</td>
                        <td>
                            {{task.typeof | nameTaskType}}
                            <template v-if="task.typeof == 'other'">
                            {{task.typeof_other}}
                            </template>
                            <template v-if="task.typeof == 'intervention'">
                                <template v-if="task.intervention_type == 'other'">
                                    {{task.intervention_type_other}}
                                </template>
                                <template v-else>
                                    {{intervention_types[task.intervention_type]}}
                                </template>
                            </template>
                        </td>
                        <td v-if="task.place != null">{{(placesdict && placesdict[task.place_id]) || task.place.name || task.place.displayedname}}</td>
                        <td v-else><span v-if="task.address != undefined">{{task.address.street}}, {{task.address.city}}</span></td>
                        <td>{{task.worker_ids | nameByIds(workers)}}</td>
                        <td>{{statuseslabels[task.status]}}</td>
                    </tr>
                </template>
            </tbody>
            <preloader v-if="loaded == false" n="6" />
        </table>
        <template v-if="listItems.length == 0 && loaded == true"><p style="font-size: 12px;">{{$t('tasks.not_found')}}</p></template>
        <day v-if="mode == 'days'" :workerItems="workerItems" :loaded="loaded" :workersLoaded="workersLoaded" :days="listWeeksItems" :selectedWorkers="selectedWorkers" :listWorkersItems="listWorkersItems" :delayedListWorkersItems="delayedListWorkersItems" v-on:taskmoved="saveTask" :placesdict="placesdict" v-on:taskClicked="showTask" v-on:reorder="reordered" :date="currentDate" @addtask="addTask" ref="days"/>
        <week v-if="mode == 'week'" :days="listWeeksItems" :loaded="loaded" :workerItems="workerItems" v-on:click="showTask" :placesdict="placesdict" v-on:taskmoved="saveTask" />
        
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import _ from 'lodash';
import Moment from 'moment';
import 'moment/locale/pl'
import { extendMoment } from 'moment-range';
import VueCookies from 'vue-cookies'

const moment = extendMoment(Moment);
moment.locale('pl')
export default {
    data: function() {
        return {
            scrollPosition: 600,
            order: 'desc',
            orderby: 'number',
            from: moment().startOf("month").format("YYYY-MM-DD"),
            to: moment().endOf("month").format("YYYY-MM-DD"),
            tasks: [],
            loadedData: {},
            reloadInterval: null,
            edit: false,
            loaded_task: false,
            selectedWorkers: [],
            typeofs: ["inspection", "installation", "intervention", "other"],
            workerslist: [],
            workerItems: [],
            workers: [],
            rangeSelected: "currentMonth",
            place_name: "",
            customers: [],
            selections: [],
            weeks: [],
            now: moment(),
            lineoffset: 0,
            hover: false,
            statuses: [],
            deletions: [],
            deletedloading: true,
            items: [
                {"name": this.$t('tasks.intervention'), "value": 'intervention:null'},
                {"name": this.$t('tasks.disinsection'), "value": 'intervention:disinsection'},
                {"name": this.$t('tasks.disinfection'), "value": 'intervention:disinfection'},
                {"name": this.$t('tasks.deratization'), "value": 'intervention:deratization'},
                {"name": this.$t('tasks.other'), "value": 'intervention:other'},
                {"name": this.$t('tasks.inspection'), "value": 'inspection:null'},
                {"name": this.$t('tasks.installation'), "value": 'installation:null'},
                {"name": this.$t('tasks.other_task'), "value": 'other:null'},
            ],
            statuslist: [
                {"name":  this.$t('tasks.statuses.dateset'), "value": "dateset"},
                {"name":  this.$t('tasks.statuses.no_date'), "value": "no_date"},
                {"name":  this.$t('tasks.statuses.pending'), "value": "pending"},
                {"name":  this.$t('tasks.statuses.finished_worker'), "value": "finished_worker"},
                {"name":  this.$t('tasks.statuses.cleared'), "value": "cleared"},
                {"name":  this.$t('tasks.statuses.refused'), "value": "refused"}
            ],
            statuseslabels: {
                "dateset":  this.$t('tasks.statuses.dateset'),
                "no_date":  this.$t('tasks.statuses.no_date'),
                "pending":  this.$t('tasks.statuses.pending'),
                "finished_worker":  this.$t('tasks.statuses.finished_worker'),
                "cleared":  this.$t('tasks.statuses.cleared'),
                "refused":  this.$t('tasks.statuses.refused')
            },
            loadedFragments: [],
            placesdict: {},
            placeAddressDict: {},

            ntask: {
                typeof: 'intervention',
                status: 'dateset',
                routine: false,
                worker_ids: [],
                place_id: null,
                startsAt: moment().format('YYYY-MM-DDTHH:mm'),
                endsAt: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
                address: {
                    name: "",
                    street: "",
                    city: "",
                    postal_code: ""
                },
                phone_number: "",
                photos: [],
                versions: [],
                comments: []
            },
            mode: 'days',
            taskstypes: [
                { name: this.$t('tasks.kindnames.inspection'), value: "inspection" },
                { name: this.$t('tasks.kindnames.installation'), value: "installation" },
                { name: this.$t('tasks.kindnames.intervention'), value: "intervention" },
                { name: this.$t('tasks.kindnames.other'), value: "other" }
            ],
            tasksnames: { 'intervention': this.$t('tasks.kindnames.intervention'), 'inspection': this.$t('tasks.kindnames.inspection'), "installation": this.$t('tasks.kindnames.installation'), 'other': this.$t('tasks.kindnames.other') },
            intervention_types: { 'deratization': this.$t('tasks.intervention_names.deratization'), 'disinfection': this.$t('tasks.intervention_names.disinfection'), 'disinsection': this.$t('tasks.intervention_names.disinsection'), 'other': this.$t('tasks.intervention_names.other') },
            loaded: false,
            workersLoaded: false,
            hours: _.range(0, 24),
            currentDate: moment(),
            calDate: moment(),
            tasksTimeRange: { startDate: moment().startOf('day').format("YYYY-MM-DD"), endDate: moment().endOf('day').format("YYYY-MM-DD") },
            instances: undefined,
            editdate: false,
            lastLoad: 0,
            map: null,
            L: null,
            taskMarkersLayer: null,
            geocodeCache: {},
            mapRenderToken: 0,
            geocodeLastRequestAt: 0,
            leafletDefaultIconConfigured: false,
            mapSearchQuery: '',
            mapSearchResults: [],
            mapSearchLoading: false,
            mapSearchRequestId: 0,
            mapSearchMarker: null,
            mapSearchDebounceTimer: null,
            mapSearchLastRequestAt: 0,
            nominatimCooldownUntil: 0,
            mapMarkersLoading: false,
            mapOverlapExpandedLayer: null,
            workerTimelineLayer: null,
            unresolvedTasksMarker: null,
            unresolvedTasksCount: 0,
            unresolvedTaskEntries: [],
            invalidAddressTasksCount: 0,
            placeFieldIssuesCount: 0,
            mapForecastEnabled: false,
            lastRenderedTaskPointsById: {},
            commuteRouteCache: {},
            commuteRouteLastRequestAt: 0,
            mapPointPickTask: null,
            mapPointPickMarker: null,
            externalGeoUnavailable: false,
            externalVehiclesUnavailable: false,
            companyGeocodePoint: null,
            companyGeocodeLookupDone: false,
            companyGeocodeLastAttemptAt: 0,
            taskMarkersLayerIsCluster: false
        }
    },
    props: {
        company_address: Object
    },
    meta: {
        title: "Zadania"
    },
    beforeRouteLeave (to, from , next) {
        this.$emit('commitState', { taskDate: this.currentDate, mode: this.mode, page: 'tasks' });
        if(this.role != 'ddd_customer' && _.isNil(this.$refs.days) != true){
            if(this.$refs.days.anyPending()){
                if(confirm(this.$t('tasks.unsaved_changes'))){
                    next()
                }else{
                    next(false)
                }
            }else{
                next()
            }
        }else{
            next()
        }
    },

    created() {
        const savedDate = localStorage.getItem('currentDate');
        if (savedDate) {
            this.selectDay(moment(savedDate));
        }
        try {
            const savedGeocodeCache = localStorage.getItem('tasks_geocode_cache_v1');
            if (savedGeocodeCache) {
                this.geocodeCache = JSON.parse(savedGeocodeCache) || {};
            }
        } catch (error) {
            this.geocodeCache = {};
        }
        this.mapForecastEnabled = false;
        localStorage.setItem('tasks_map_forecast_enabled', '0');
        this.fetch_places();
        this.generateWeeks();
        var fromCookies = this.$cookies.get('collapsedworkers') || "[]";
        if (fromCookies != null) {
            var mem = JSON.parse(fromCookies);
            this.selectedWorkers.push(...mem);
        }
    },
    mounted() {
        window.scrollTo(0, 6 * 52);
        var that = this;
        var starts = document.querySelectorAll('.timestartpicker');
        var ends = document.querySelectorAll('.timeendpicker');
        if(_.isUndefined(this.$parent.state.tasksDate) == false){
            this.selectDay(this.$parent.state.tasksDate);
            this.mode = this.$parent.state.tasksMode;
        }
        var translates = {
            cancel: this.$t('menu.buttons.cancel'),
            clear: this.$t('menu.buttons.clear'),
            done: this.$t('menu.ok'),

        }
        var startsTime = [];
        var endsTime = [];
        var instances = M.Timepicker.init(starts, {
            twelveHour: false,
            i18n: translates,
            onSelect: function(hh, mm) {
                startsTime = [hh, mm];
            },
            onCloseStart: function(a) {},
            onCloseEnd: function(a) {
                if (startsTime.length == 2) {
                    that.taskStartAtTime = moment({ hour: startsTime[0], minutes: startsTime[1] }).format("HH:mm");
                }
            },
            onOpenStart: function(a) {
                var that = this;
                that.hasEvent = false;
                var cancelbtn = a.querySelectorAll('.timepicker-close:nth-child(1)')[0];
                var okbtn = a.querySelectorAll('.timepicker-close:nth-child(2)')[0];
                var cancelfn = function(that) {
                    cancelbtn.removeEventListener('click', cancelfn)
                };
                var okfn = function(that) {
                    okbtn.removeEventListener('click', okfn)
                };
                cancelbtn.addEventListener('click', cancelfn);
                okbtn.addEventListener('click', okfn);
            }
        });
        var instances = M.Timepicker.init(ends, {
            twelveHour: false,
            i18n: translates,
            onSelect: function(hh, mm) {
                endsTime = [hh, mm];
            },
            onCloseStart: function(a) {},
            onCloseEnd: function(a) {
                if (endsTime.length == 2) {
                    that.taskEndsAtTime = moment({ hour: endsTime[0], minutes: endsTime[1] }).format("HH:mm");
                }
            },
            onOpenStart: function(a) {
                var cancelbtn = a.querySelectorAll('.timepicker-close:nth-child(1)')[0];
                var okbtn = a.querySelectorAll('.timepicker-close:nth-child(2)')[0];
                var that = this;
                that.hasEvent = false;
                var cancelfn = function(that) {
                    cancelbtn.removeEventListener('click', cancelfn)
                };
                var okfn = function(that) {
                    okbtn.removeEventListener('click', okfn)
                };
                cancelbtn.addEventListener('click', cancelfn)
                okbtn.addEventListener('click', okfn)
            }
        });
        window.addEventListener('scroll', this.updateScrollPosition);
        this.reloadInterval = setInterval(() => {
             this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        }, 30000);
    },
    beforeDestroy() {
        if (this.mapSearchDebounceTimer) {
            clearTimeout(this.mapSearchDebounceTimer);
            this.mapSearchDebounceTimer = null;
        }
        this.cancelMapPointPick();
        this.clearMapOverlapExpanded();
        this.clearWorkerTimelineLayer();
        this.clearUnresolvedTasksMarker();
        if (this.countdownTimer) {
            clearTimeout(this.countdownTimer);
            clearInterval(this.reloadInterval);
            window.removeEventListener('scroll', this.updateScrollPosition);
        }
    },
    methods: {
        startCountdown() {
            if (this.countdownTimer) {
                clearTimeout(this.countdownTimer);
            }
            this.countdownTimer = setTimeout(() => {
                localStorage.setItem('currentDate', this.currentDate.format());
            }, 30000); // 30 seconds
        },
        updateCurrentDate(newDate) {
            this.currentDate = newDate;
            this.calDate = newDate.clone();
            this.startCountdown();
        },
        ensureExternalStylesheet(href) {
            if (!href) return;
            const existing = document.querySelector(`link[rel="stylesheet"][href="${href}"]`);
            if (existing) return;
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
        },
        ensureExternalScript(src) {
            if (!src) return Promise.resolve();
            const existing = document.querySelector(`script[src="${src}"]`);
            if (existing) {
                if (existing.dataset.loaded === 'true') return Promise.resolve();
                return new Promise((resolve) => {
                    existing.addEventListener('load', () => resolve(), { once: true });
                });
            }
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => {
                    script.dataset.loaded = 'true';
                    resolve();
                };
                script.onerror = () => reject(new Error(`Failed to load ${src}`));
                document.head.appendChild(script);
            });
        },
        async loadMarkerClusterDependencies() {
            if (this.L && typeof this.L.markerClusterGroup === 'function') return;
            if (this.L) {
                window.L = this.L;
            }
            this.ensureExternalStylesheet('https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css');
            this.ensureExternalStylesheet('https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css');
            await this.ensureExternalScript('https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js');
            if (window.L && this.L !== window.L) {
                this.L = window.L;
            }
        },
        async activateMap() {
          var App = {};
          this.mapVisible = true;
          if (!this.map) {
            const L = await import("leaflet");
                        this.L = L;
            await import("leaflet/dist/leaflet.css");
                            if (!this.leafletDefaultIconConfigured) {
                                delete L.Icon.Default.prototype._getIconUrl;
                                L.Icon.Default.mergeOptions({
                                    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
                                    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
                                    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
                                });
                                this.leafletDefaultIconConfigured = true;
                            }
              var greenIcon = new L.Icon({
                iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
                shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41]
              });
              var redIcon = new L.Icon({
                iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
                shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                shadowSize: [41, 41]
              });
                            function deg2rad(deg) {
                                return deg * (Math.PI / 180);
                            }
                            function rad2deg(rad) {
                                return rad * (180 / Math.PI);
                            }
                            function normalizeAngle(angle) {
                                return ((angle % 360) + 360) % 360;
                            }
                            function bearingBetween(from, to) {
                                if (!from || !to) return null;
                                const lat1 = deg2rad(from.lat);
                                const lat2 = deg2rad(to.lat);
                                const dLng = deg2rad(to.lng - from.lng);
                                const y = Math.sin(dLng) * Math.cos(lat2);
                                const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
                                const angle = rad2deg(Math.atan2(y, x));
                                return normalizeAngle(angle);
                            }
                            function directionFromData(data) {
                                const fromPayload = data && (data.heading ?? data.hdg ?? data.course ?? data.crs ?? data.brg);
                                if (fromPayload === null || fromPayload === undefined || fromPayload === '') return null;
                                const parsed = parseFloat(fromPayload);
                                return Number.isFinite(parsed) ? normalizeAngle(parsed) : null;
                            }
                            function positionChanged(from, to) {
                                if (!from || !to) return false;
                                const eps = 0.00001;
                                return Math.abs(from.lat - to.lat) > eps || Math.abs(from.lng - to.lng) > eps;
                            }
                            function vehicleIcon(color, angle) {
                                const rot = normalizeAngle((angle || 0) - 90);
                                return L.divIcon({
                                    className: '',
                                    html: `<span style="display:inline-block;width:26px;height:26px;transform:rotate(${rot}deg);transform-origin:center center;"><span style="display:inline-block;width:26px;height:26px;background-color:${color};-webkit-mask:url('https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/solid/car-side.svg') center / contain no-repeat;mask:url('https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/solid/car-side.svg') center / contain no-repeat;"></span></span>`,
                                    iconSize: [26, 26],
                                    iconAnchor: [13, 13],
                                    popupAnchor: [0, -12]
                                });
                            }
            await this.$nextTick();
              this.map = L.map(this.$refs.map).setView([52.4064, 16.9252], 13);
                            this.map.on('click', this.pickMapPoint);

              L.tileLayer(
                "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              ).addTo(this.map);
                            await this.loadMarkerClusterDependencies();
              function loadScript(path) {
                  return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = path;
                    script.onload = () => resolve(script);
                    script.onerror = () => reject(new Error(`Failed to load ${path}`));
                    document.head.appendChild(script);
                  });
                }

                try {
                    await loadScript('https://coordscollector.mobipest.pl/assets/application-057cfb9a79a6545b995fe24aa279a24085233d2df232fb3aa763620852f15df4.js')
                    App.cable = ActionCable.createConsumer(`wss://coordscollector.mobipest.pl/cable`);
                    App.vehicles = {};
                    var vehicles = await axios.get('https://coordscollector.mobipest.pl/vehicles.json');
                    var fg = L.featureGroup([]).addTo(this.map);
                    for (let index = 0; index < vehicles.data.length; index++) {
                        let v = vehicles.data[index];
                        v.coordinates = [];
                        const startPoint = { lat: v.reads.lt, lng: v.reads.ln };
                        v.heading = 0;
                        v.lastLatLng = startPoint;
                        v.marker = L.marker([v.reads.lt, v.reads.ln]).bindTooltip(v.name,
                            {
                                direction: 'right'
                            }
                        ).setIcon(vehicleIcon('#1565c0', v.heading)).addTo(fg);
                        v.polygon = L.polyline(v.coordinates, {color: 'red', noClip: true}).addTo(fg);
                        App.messaging = App.cable.subscriptions.create({ channel: 'VehicleChannel', id: v.id }, {
                          received: function(data) {
                            $(this).trigger('newone', data);
                            var pkt = {lat: data.lt, lng: data.ln};
                            const currentVehicle = App.vehicles[v.id];
                            const fromTelemetry = directionFromData(data);
                            const fromMotion = bearingBetween(currentVehicle.lastLatLng, pkt);
                            const nextHeading = fromTelemetry ?? fromMotion ?? currentVehicle.heading ?? 0;
                            const moved = positionChanged(currentVehicle.lastLatLng, pkt);
                            currentVehicle.heading = nextHeading;
                            currentVehicle.lastLatLng = pkt;
                            if(moved){
                                App.vehicles[v.id].marker.setIcon(vehicleIcon('#2e7d32', nextHeading));
                            }else{
                                App.vehicles[v.id].marker.setIcon(vehicleIcon('#c62828', nextHeading));
                            }
                            App.vehicles[v.id].marker.setLatLng([data.lt, data.ln]);
                            App.vehicles[v.id].polygon.addLatLng([data.lt, data.ln]);

                          },
                          sendMessage: function(messageBody) {
                            this.perform('foobar', { body: messageBody, to: otherPlayerUuid });
                          }
                         }
                        );
                        App.vehicles[v.id] = v;
                    }
                } catch (error) {
                    this.markExternalVehiclesUnavailable();
                }
            await this.renderTaskMarkers();
          } else {
            this.$nextTick(async () => {
                this.map.invalidateSize();
                await this.renderTaskMarkers();
            });
          }

        },
        normalizeAddressPart(value) {
            value = (value || "").toString().trim();
            value = value.replace(/\bul\.\s*/gi, "")
              .replace(/\bal\.\s*/gi, "Aleja ")
              .replace(/\bos\.\s*/gi, "Osiedle ")
              .replace(/\bpl\.\s*/gi, "Plac ")
              .replace(/\s+/g, " ")
              .trim();
            return value;
        },
        wait(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        companyAddressParts() {
            const c = this.company_address || {};
            const nested = c.address || {};
            const street = this.normalizeAddressPart(c.street || c.address_street || nested.street);
            const postalCode = this.normalizeAddressPart(c.postal_code || c.postalCode || c.zip || c.zip_code || nested.postal_code || nested.postalCode || nested.zip || nested.zip_code);
            const city = this.normalizeAddressPart(c.city || c.town || nested.city || nested.town);
            return { street, postalCode, city };
        },
        defaultCompanyCity() {
            return this.companyAddressParts().city;
        },
        queryLooksLikeContainsCity(query) {
            const q = this.normalizeAddressPart(query);
            if (!q) return false;

            const qLower = q.toLowerCase();
            const companyCity = this.defaultCompanyCity();
            if (companyCity && qLower.includes(companyCity.toLowerCase())) return true;
            if (/\b\d{2}-\d{3}\b/.test(qLower)) return true;

            const streetIndicators = [
                ' ul ', ' ul.', ' ulica ', ' al ', ' al.', ' aleja ', ' os ', ' os.', ' osiedle ',
                ' plac ', ' pl ', ' pl.', ' rondo ', ' nr ', ' m. ', ' lok ', ' lok.'
            ];
            const wrapped = ` ${qLower} `;
            const hasStreetIndicator = streetIndicators.some((marker) => wrapped.includes(marker));
            const hasBuildingNumber = /\b\d+[a-z]?\b/i.test(qLower);

            // Queries that look like a standalone locality/city should not get company city appended.
            const plainTextWithoutPunctuation = qLower.replace(/[,.;]/g, ' ').trim();
            const words = plainTextWithoutPunctuation.split(/\s+/).filter(Boolean);
            const likelyStandaloneLocality = words.length >= 1 && words.length <= 3 && !hasStreetIndicator && !hasBuildingNumber;
            if (likelyStandaloneLocality) return true;

            const parts = q.split(',').map((part) => this.normalizeAddressPart(part)).filter(Boolean);
            if (parts.length >= 2) {
                const lastPart = parts[parts.length - 1];
                if (lastPart.length >= 3 && !/^\d+$/.test(lastPart)) return true;
            }

            return false;
        },
        appendDefaultCityIfMissing(query) {
            const q = this.normalizeAddressPart(query);
            const { postalCode, city } = this.companyAddressParts();
            const companyLocality = [postalCode, city].filter(Boolean).join(' ');
            if (!q || !companyLocality) return q;
            if (this.queryLooksLikeContainsCity(q)) return q;
            return `${q}, ${companyLocality}`;
        },
        companyAddressToGeocode() {
            const { street, postalCode, city } = this.companyAddressParts();
            console.log(this.companyAddressParts());
            const parts = [
                street,
                postalCode,
                city,
                'Polska'
            ].filter(Boolean);
            return _.uniq(parts).join(', ');
        },
        companyCityToGeocode() {
            const city = this.defaultCompanyCity();
            if (!city) return '';
            return `${city}, Polska`;
        },
        haversineKm(a, b) {
            if (!a || !b) return Number.POSITIVE_INFINITY;
            const toRad = (deg) => deg * Math.PI / 180;
            const R = 6371;
            const dLat = toRad((b.lat || 0) - (a.lat || 0));
            const dLng = toRad((b.lng || 0) - (a.lng || 0));
            const lat1 = toRad(a.lat || 0);
            const lat2 = toRad(b.lat || 0);
            const x = Math.sin(dLat / 2) * Math.sin(dLat / 2)
                + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
            const y = 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
            return R * y;
        },
        formatDistanceKm(distanceKm) {
            if (!Number.isFinite(distanceKm)) return '';
            if (distanceKm < 1) return `${Math.round(distanceKm * 1000)} m`;
            return `${distanceKm.toFixed(1)} km`;
        },
        pointFromObject(source) {
            if (!source || typeof source !== 'object') return null;
            const latRaw = source.lat ?? source.latitude ?? source.lt ?? source.geo_lat ?? source.gps_lat;
            const lngRaw = source.lng ?? source.lon ?? source.longitude ?? source.ln ?? source.geo_lng ?? source.gps_lng;
            const lat = parseFloat(latRaw);
            const lng = parseFloat(lngRaw);
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                return { lat, lng };
            }
            return null;
        },
        taskPointFromData(task) {
            const place = (task && task.place) || {};
            const address = (task && task.address) || {};
            const placeAddress = place.address || {};
            const placeByIdAddress = _.get(this.placeAddressDict, task && task.place_id) || {};
            const candidates = [task, address, place, placeAddress, placeByIdAddress];
            for (let i = 0; i < candidates.length; i++) {
                const point = this.pointFromObject(candidates[i]);
                if (point) return point;
            }
            return null;
        },
        async getCompanyGeocodePoint() {
            if (this.companyGeocodeLookupDone && this.companyGeocodePoint) return this.companyGeocodePoint;
            if (this.companyGeocodeLookupDone && !this.companyGeocodePoint && this.isNominatimCoolingDown()) return null;
            if (!this.companyGeocodePoint && (Date.now() - this.companyGeocodeLastAttemptAt) < 30000) return null;

            this.companyGeocodeLastAttemptAt = Date.now();

            const c = this.company_address || {};
            const nested = c.address || {};
            const latRaw = c.lat ?? c.latitude ?? c.lt ?? c.geo_lat ?? c.gps_lat ?? nested.lat ?? nested.latitude ?? nested.lt;
            const lngRaw = c.lng ?? c.lon ?? c.longitude ?? c.ln ?? c.geo_lng ?? c.gps_lng ?? nested.lng ?? nested.lon ?? nested.longitude ?? nested.ln;
            const lat = parseFloat(latRaw);
            const lng = parseFloat(lngRaw);
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                this.companyGeocodePoint = { lat, lng };
                this.companyGeocodeLookupDone = true;
                return this.companyGeocodePoint;
            }

            const fullAddressKey = this.companyAddressToGeocode();
            const cityKey = this.companyCityToGeocode();
            const { postalCode, city } = this.companyAddressParts();
            const localityKey = [postalCode, city, 'Polska'].filter(Boolean).join(', ');
            const addressCandidates = _.uniq([
                fullAddressKey,
                localityKey,
                cityKey
            ].filter((value) => value && value !== 'Polska'));

            if (addressCandidates.length === 0) {
                this.companyGeocodeLookupDone = false;
                return null;
            }

            let point = null;
            for (let i = 0; i < addressCandidates.length; i++) {
                point = await this.geocodeAddress(addressCandidates[i], { ignoreCachedNull: true });
                if (point) break;
            }

            this.companyGeocodePoint = point || null;
            this.companyGeocodeLookupDone = !!this.companyGeocodePoint;
            console.log('Company geocode point:', this.companyGeocodePoint);
            return this.companyGeocodePoint;
        },
        isNominatimCoolingDown() {
            return Date.now() < this.nominatimCooldownUntil;
        },
        applyNominatimCooldown(ms = 120000) {
            this.nominatimCooldownUntil = Date.now() + ms;
        },
        mapSearchInputChanged() {
            const q = (this.mapSearchQuery || '').trim();
            if (this.mapSearchDebounceTimer) {
                clearTimeout(this.mapSearchDebounceTimer);
                this.mapSearchDebounceTimer = null;
            }
            if (this.externalGeoUnavailable) {
                this.mapSearchResults = [];
                this.mapSearchLoading = false;
                return;
            }
            if (q.length < 3) {
                this.mapSearchResults = [];
                this.mapSearchLoading = false;
                return;
            }
            this.mapSearchDebounceTimer = setTimeout(() => {
                this.searchMapSuggestions(q);
            }, 450);
        },
        clearMapSearch() {
            this.mapSearchQuery = '';
            this.mapSearchResults = [];
            this.mapSearchLoading = false;
            this.mapSearchRequestId += 1;
            if (this.mapSearchDebounceTimer) {
                clearTimeout(this.mapSearchDebounceTimer);
                this.mapSearchDebounceTimer = null;
            }
            if (this.mapSearchMarker && this.map && this.map.hasLayer(this.mapSearchMarker)) {
                this.map.removeLayer(this.mapSearchMarker);
            }
            this.mapSearchMarker = null;
        },
        clearMapOverlapExpanded() {
            if (this.mapOverlapExpandedLayer && this.map) {
                this.map.removeLayer(this.mapOverlapExpandedLayer);
            }
            this.mapOverlapExpandedLayer = null;
        },
        clearWorkerTimelineLayer() {
            if (this.workerTimelineLayer && this.map) {
                this.map.removeLayer(this.workerTimelineLayer);
            }
            this.workerTimelineLayer = null;
        },
        clearUnresolvedTasksMarker() {
            if (this.unresolvedTasksMarker && this.map) {
                this.map.removeLayer(this.unresolvedTasksMarker);
            }
            this.unresolvedTasksMarker = null;
        },
        markExternalGeoUnavailable() {
            this.externalGeoUnavailable = true;
            this.mapSearchLoading = false;
            this.mapSearchResults = [];
        },
        markExternalVehiclesUnavailable() {
            this.externalVehiclesUnavailable = true;
        },
        unresolvedTaskAddress(entry) {
            const task = entry && entry.task;
            if (!task) return 'Nieznane zadanie';
            if (task.place != null) {
                return this.taskPlaceLabel(task) || 'Brak nazwy obiektu';
            }
            const parts = [task.address?.street, task.address?.postal_code, task.address?.city].filter(Boolean);
            if (parts.length > 0) return parts.join(', ');
            return this.taskAddressToGeocode(task) || 'Brak adresu';
        },
        unresolvedTaskReason(entry) {
            if (!entry) return 'Brak danych';
            if (entry.reason === 'bad_address') return 'Adres wyglada na nieprawidlowy';
            if (entry.reason === 'place_invalid') return 'Obiekt bez poprawnych wspolrzednych';
            if (entry.reason === 'missing_location') return 'Brak lokalizacji';
            return 'Brak danych';
        },
        startResolveUnresolvedTask(entry) {
            if (!entry || !entry.task) return;
            this.mapPointPickTask = entry.task;
            if (this.map && this.map.flyTo) {
                const point = this.fallbackMapPoint();
                this.map.flyTo([point.lat, point.lng], 14);
            }
        },
        focusUnresolvedTask(entry) {
            if (!entry || !entry.task || !this.map) return;
            const point = this.taskPointFromData(entry.task) || this.fallbackMapPoint();
            this.map.flyTo([point.lat, point.lng], 14);
        },
        cancelMapPointPick() {
            this.mapPointPickTask = null;
            if (this.mapPointPickMarker && this.map && this.map.hasLayer(this.mapPointPickMarker)) {
                this.map.removeLayer(this.mapPointPickMarker);
            }
            this.mapPointPickMarker = null;
        },
        async pickMapPoint(event) {
            if (!this.mapPointPickTask || !event || !event.latlng) return;
            const { lat, lng } = event.latlng;
            const task = this.mapPointPickTask;
            task.address = task.address || {};
            this.$set(task.address, 'lat', lat);
            this.$set(task.address, 'lng', lng);
            this.$set(task.address, 'latitude', lat);
            this.$set(task.address, 'longitude', lng);
            task.place_id = null;

            if (this.mapPointPickMarker && this.map && this.map.hasLayer(this.mapPointPickMarker)) {
                this.map.removeLayer(this.mapPointPickMarker);
            }
            this.mapPointPickMarker = this.L.marker([lat, lng], { riseOnHover: true })
                .addTo(this.map)
                .bindTooltip('Wskazany punkt', { direction: 'top' });

            this.mapPointPickTask = null;
            const saveResult = await this.saveTask(task);
            if (saveResult !== false) {
                this.cancelMapPointPick();
            }
            if (this.map) {
                await this.renderTaskMarkers();
            }
        },
        fallbackMapPoint() {
            const companyPoint = this.pointFromObject(this.company_address) || this.pointFromObject((this.company_address || {}).address);
            if (companyPoint) return companyPoint;
            if (this.map && this.map.getCenter) {
                const center = this.map.getCenter();
                if (center) return { lat: center.lat, lng: center.lng };
            }
            return { lat: 52.4064, lng: 16.9252 };
        },
        isTaskPointPlausible(task, point, options = {}) {
            if (!task || !point) return false;
            const isGeocoded = !!options.isGeocoded;
            const hasPlace = !!options.hasPlace;
            if (!isGeocoded && !hasPlace) return true;

            const companyPoint = this.pointFromObject(this.company_address) || this.pointFromObject((this.company_address || {}).address);
            if (!companyPoint) return true;

            const distanceKm = this.haversineKm(companyPoint, point);
            if (!Number.isFinite(distanceKm)) return false;

            const maxPlausibleDistanceKm = 120;
            return distanceKm <= maxPlausibleDistanceKm;
        },
        renderUnresolvedTasksPlaceholder(unresolvedEntries) {
            this.clearUnresolvedTasksMarker();
            if (!this.map || !this.L || !unresolvedEntries || unresolvedEntries.length === 0) {
                this.unresolvedTasksCount = 0;
                this.unresolvedTaskEntries = [];
                this.invalidAddressTasksCount = 0;
                this.placeFieldIssuesCount = 0;
                return;
            }

            const point = this.fallbackMapPoint();
            const icon = this.L.divIcon({
                className: 'tasks-unresolved-cluster',
                html: `<span>?</span><small>${unresolvedEntries.length}</small>`,
                iconSize: [38, 38],
                iconAnchor: [19, 19]
            });

            const badAddressCount = unresolvedEntries.filter((entry) => entry.reason === 'bad_address').length;
            const placeIssuesCount = unresolvedEntries.filter((entry) => entry.reason === 'place_invalid').length;
            this.unresolvedTasksCount = unresolvedEntries.length;
            this.unresolvedTaskEntries = unresolvedEntries;
            this.invalidAddressTasksCount = badAddressCount;
            this.placeFieldIssuesCount = placeIssuesCount;

            const lines = unresolvedEntries.slice(0, 10).map((entry) => {
                const task = entry.task;
                const where = task.place != null
                    ? this.taskPlaceLabel(task)
                    : [task.address?.street, task.address?.city].filter(Boolean).join(', ');
                const start = moment(task.startsAt).format('YYYY-MM-DD HH:mm');
                const reasonLabel = entry.reason === 'bad_address'
                    ? 'bledny adres'
                    : entry.reason === 'place_invalid'
                        ? 'miejsce bez poprawnych wspolrzednych'
                        : 'brak lokalizacji';
                return `${_.escape(start)} | ${_.escape(where || 'brak adresu')} | ${reasonLabel}`;
            });
            const more = unresolvedEntries.length > 10 ? `<br/>... +${unresolvedEntries.length - 10} kolejnych` : '';
            const cause = this.externalGeoUnavailable
                ? 'Przyczyna: geokodowanie zewnetrzne niedostepne (CORS/offline).'
                : `Przyczyna: brak lub niepoprawny adres/wspolrzedne. Bledne adresy: ${badAddressCount}. Problemy z miejscem: ${placeIssuesCount}.`;
            const popupHtml = `<strong>Niezlokalizowane zadania: ${unresolvedEntries.length}</strong><br/>${cause}<br/>${lines.join('<br/>')}${more}`;

            this.unresolvedTasksMarker = this.L.marker([point.lat, point.lng], { icon, riseOnHover: true }).addTo(this.map);
            this.unresolvedTasksMarker.bindTooltip(`Niezlokalizowane: ${unresolvedEntries.length}`, { direction: 'top' });
            this.unresolvedTasksMarker.on('click', () => {
                this.L.popup({ maxWidth: 560 }).setLatLng([point.lat, point.lng]).setContent(popupHtml).openOn(this.map);
            });
        },
        expandOverlappingMarkers(group, centerPoint) {
            if (!this.map || !this.L || !group || !group.items || group.items.length < 2) return;

            this.clearMapOverlapExpanded();

            const currentZoom = this.map.getZoom ? this.map.getZoom() : 14;
            const targetZoom = Math.max(currentZoom, 18);
            if (targetZoom > currentZoom) {
                this.map.flyTo([centerPoint.lat, centerPoint.lng], targetZoom, { duration: 0.35 });
            }

            const expandedLayer = this.L.featureGroup([]).addTo(this.map);
            this.mapOverlapExpandedLayer = expandedLayer;

            const radiusPx = 28;
            const count = group.items.length;
            const basePoint = this.map.latLngToContainerPoint([centerPoint.lat, centerPoint.lng]);
            const expandedBounds = [];

            for (let i = 0; i < count; i++) {
                const angle = (Math.PI * 2 * i) / count;
                const dx = Math.cos(angle) * radiusPx;
                const dy = Math.sin(angle) * radiusPx;
                const spreadContainerPoint = this.L.point(basePoint.x + dx, basePoint.y + dy);
                const spreadLatLng = this.map.containerPointToLatLng(spreadContainerPoint);
                expandedBounds.push(spreadLatLng);

                const leg = this.L.polyline([
                    [centerPoint.lat, centerPoint.lng],
                    [spreadLatLng.lat, spreadLatLng.lng]
                ], {
                    color: '#607d8b',
                    weight: 1,
                    opacity: 0.7,
                    dashArray: '3,3'
                });
                leg.addTo(expandedLayer);

                const item = group.items[i];
                const marker = this.L.marker([spreadLatLng.lat, spreadLatLng.lng], item.markerOptions);
                marker.on('click', () => this.showTask(item.task));
                marker.addTo(expandedLayer);
            }

            const closeExpanded = () => {
                this.clearMapOverlapExpanded();
                if (this.map) {
                    this.map.off('click', closeExpanded);
                    this.map.off('zoomstart', closeExpanded);
                }
            };

            this.map.on('click', closeExpanded);
            this.map.on('zoomstart', closeExpanded);

            if (expandedBounds.length > 0) {
                this.map.fitBounds(this.L.latLngBounds(expandedBounds), { padding: [24, 24], maxZoom: 19 });
            }
        },
        async searchMapSuggestions(query) {
            const q = this.normalizeAddressPart(query);
            if (q.length < 3) {
                this.mapSearchResults = [];
                this.mapSearchLoading = false;
                return;
            }
            if (this.externalGeoUnavailable) {
                this.mapSearchResults = [];
                this.mapSearchLoading = false;
                return;
            }
            if (this.isNominatimCoolingDown()) {
                this.mapSearchResults = [];
                this.mapSearchLoading = false;
                return;
            }

            const requestId = ++this.mapSearchRequestId;
            this.mapSearchLoading = true;
            try {
                const sinceLastRequest = Date.now() - this.mapSearchLastRequestAt;
                const delayMs = Math.max(0, 1200 - sinceLastRequest);
                if (delayMs > 0) {
                    await this.wait(delayMs);
                }
                this.mapSearchLastRequestAt = Date.now();
                const response = await axios.get('https://nominatim.openstreetmap.org/search', {
                    params: {
                        q,
                        format: 'jsonv2',
                        limit: 20,
                        countrycodes: 'pl',
                        addressdetails: 1,
                        'accept-language': 'pl'
                    }
                });
                if (requestId !== this.mapSearchRequestId) return;
                const results = response.data || [];
                const companyPoint = await this.getCompanyGeocodePoint();
                if (companyPoint) {
                    const withDistances = results.map((item) => {
                        const itemLat = parseFloat(item.lat);
                        const itemLng = parseFloat(item.lon);
                        const distance = Number.isFinite(itemLat) && Number.isFinite(itemLng)
                            ? this.haversineKm(companyPoint, { lat: itemLat, lng: itemLng })
                            : Number.POSITIVE_INFINITY;
                        return { ...item, _distanceKm: distance };
                    });
                    this.mapSearchResults = _.sortBy(withDistances, (item) => item._distanceKm).slice(0, 8);
                } else {
                    this.mapSearchResults = results.slice(0, 8).map((item) => ({ ...item, _distanceKm: NaN }));
                }
            } catch (error) {
                if (requestId !== this.mapSearchRequestId) return;
                const statusCode = _.get(error, 'response.status');
                if (statusCode == 429) {
                    this.applyNominatimCooldown(180000);
                }
                if (!statusCode) {
                    this.markExternalGeoUnavailable();
                }
                this.mapSearchResults = [];
            } finally {
                if (requestId === this.mapSearchRequestId) {
                    this.mapSearchLoading = false;
                }
            }
        },
        normalizePlPostalCode(input) {
            input = (input || "").toString().trim();
            const digits = input.replace(/\D/g, "");
            if (digits.length !== 5) return null;
            return `${digits.slice(0,2)}-${digits.slice(2)}`;
        },
        selectMapSuggestion(item) {
            const lat = parseFloat(item.lat);
            const lng = parseFloat(item.lon);
            if (!Number.isFinite(lat) || !Number.isFinite(lng) || !this.map || !this.L) return;

            this.mapSearchQuery = item.display_name || this.mapSearchQuery;
            this.mapSearchResults = [];
            this.map.flyTo([lat, lng], 16);
            if (this.mapSearchMarker && this.map.hasLayer(this.mapSearchMarker)) {
                this.map.removeLayer(this.mapSearchMarker);
            }
            this.mapSearchMarker = this.L.marker([lat, lng]).addTo(this.map).bindTooltip('Wynik wyszukiwania', {
                direction: 'top'
            }).openTooltip();
            this.mapSearchMarker.on('click', () => this.openAddTaskWithAddress(item));
        },
        nominatimAddressFromItem(item) {
            const addr = (item && item.address) || {};
            const fallbackParts = this.normalizeAddressPart(item && item.display_name).split(',').map((part) => this.normalizeAddressPart(part)).filter(Boolean);
            const fallbackStreet = fallbackParts.length > 0 ? fallbackParts[0] : '';
            const fallbackCity = fallbackParts.length > 1 ? fallbackParts[1] : this.defaultCompanyCity();
            const streetParts = [
                this.normalizeAddressPart(addr.road),
                this.normalizeAddressPart(addr.house_number)
            ].filter(Boolean);
            const city = this.normalizeAddressPart(addr.city)
                || this.normalizeAddressPart(addr.town)
                || this.normalizeAddressPart(addr.village)
                || this.normalizeAddressPart(addr.county)
                || fallbackCity
                || this.defaultCompanyCity();

            return {
                name: this.normalizeAddressPart(item && (item.name || item.display_name)) || fallbackStreet,
                street: streetParts.join(' ') || fallbackStreet,
                city: city,
                postal_code: this.normalizeAddressPart(addr.postcode)
            };
        },
        openAddTaskWithAddress(item) {
            const address = this.nominatimAddressFromItem(item);
            this.addTask();
            this.ntask.place_id = null;
            this.ntask.routine = false;
            this.ntask.address = {
                ...(this.ntask.address || {}),
                name: address.name || '',
                street: address.street || '',
                city: address.city || '',
                postal_code: address.postal_code || ''
            };
            this.$forceUpdate();
        },
        async mapSearchByEnter() {
            if (this.externalGeoUnavailable) return;
            if (this.mapSearchResults.length > 0) {
                this.selectMapSuggestion(this.mapSearchResults[0]);
                return;
            }
            const point = await this.geocodeAddress(this.appendDefaultCityIfMissing(this.mapSearchQuery));
            if (!point || !this.map || !this.L) return;
            this.map.flyTo([point.lat, point.lng], 16);
            if (this.mapSearchMarker && this.map.hasLayer(this.mapSearchMarker)) {
                this.map.removeLayer(this.mapSearchMarker);
            }
            this.mapSearchMarker = this.L.marker([point.lat, point.lng]).addTo(this.map).bindTooltip('Wynik wyszukiwania', {
                direction: 'top'
            }).openTooltip();
        },
        taskAddressToGeocode(task) {
            const address = task.address || {};
            const placeAddress = (task.place && task.place.address) || {};
            const placeByIdAddress = _.get(this.placeAddressDict, task && task.place_id) || {};
            const street = this.normalizeAddressPart(address.street)
                || this.normalizeAddressPart(placeAddress.street)
                || this.normalizeAddressPart(placeByIdAddress.street)
                || this.normalizeAddressPart(placeByIdAddress.address_street);
            const postalCodeRaw =
                address.postal_code ||
                placeAddress.postal_code ||
                placeByIdAddress.postal_code ||
                placeByIdAddress.postalCode ||
                placeByIdAddress.zip ||
                placeByIdAddress.zip_code;

            const postalCode = this.normalizePlPostalCode(postalCodeRaw);
            const explicitCity = this.normalizeAddressPart(address.city)
                || this.normalizeAddressPart(placeAddress.city)
                || this.normalizeAddressPart(placeByIdAddress.city)
                || this.normalizeAddressPart(placeByIdAddress.town);
            const city = explicitCity || (this.queryLooksLikeContainsCity(street) ? '' : this.defaultCompanyCity());
            const parts = [
                street,
                postalCode,
                city,
                'Polska'
            ].filter(Boolean);
            return _.uniq(parts).join(', ');
        },
        taskGeocodeCandidates(task) {
            const address = (task && task.address) || {};
            const placeAddress = (task && task.place && task.place.address) || {};
            const placeByIdAddress = _.get(this.placeAddressDict, task && task.place_id) || {};

            const postalCodeRaw =
                address.postal_code ||
                placeAddress.postal_code ||
                placeByIdAddress.postal_code ||
                placeByIdAddress.postalCode ||
                placeByIdAddress.zip ||
                placeByIdAddress.zip_code;
            const postalCode = this.normalizePlPostalCode(postalCodeRaw);

            const explicitCity = this.normalizeAddressPart(address.city)
                || this.normalizeAddressPart(placeAddress.city)
                || this.normalizeAddressPart(placeByIdAddress.city)
                || this.normalizeAddressPart(placeByIdAddress.town)
                || this.defaultCompanyCity();

            const placeName = this.normalizeAddressPart(this.taskPlaceLabel(task));
            const placeDispName = this.normalizeAddressPart(this.taskPlaceDispLabel(task));
            const addressName = this.normalizeAddressPart(address.name);
            const fullAddress = this.taskAddressToGeocode(task);

            const locality = [postalCode, explicitCity, 'Polska'].filter(Boolean).join(', ');
            const cityCountry = [explicitCity, 'Polska'].filter(Boolean).join(', ');

            const candidates = [
                fullAddress,
                placeDispName ? [placeDispName, locality || cityCountry].filter(Boolean).join(', ') : '',
                addressName ? [addressName, locality || cityCountry].filter(Boolean).join(', ') : '',
                addressName ? [addressName, 'Polska'].filter(Boolean).join(', ') : '',
                locality,
		postalCode
            ];

            return _.uniq(candidates.map((item) => (item || '').trim()).filter((item) => item.length > 0));
        },
        taskPlaceLabel(task) {
            const placeId = task && task.place_id;
            const dictLabel = placeId != null ? _.get(this.placesdict, placeId) : null;
            if (dictLabel) return dictLabel;
            const place = (task && task.place) || {};
            return place.name || place.displayedname || '';
        },
        taskPlaceDispLabel(task) {
            const placeId = task && task.place_id;
            const dictLabel = placeId != null ? _.get(this.placesdict, placeId) : null;
            if (dictLabel) return dictLabel;
            const place = (task && task.place) || {};
            return place.displayedname || '';
        },
        taskPopupContent(task) {
            const where = task.place != null ? this.taskPlaceLabel(task) : [task.address?.street, task.address?.city].filter(Boolean).join(', ');
            const typeKey = task.kind || task.typeof;
            const kind = this.tasksnames[typeKey] || typeKey || '';
            const status = this.statuseslabels[task.status] || task.status || '';
            const statusPrefix = this.$t('tasks.list_headers.status');
            return `<strong>${_.escape(kind)}</strong><br/>${moment(task.startsAt).format('YYYY-MM-DD HH:mm')} - ${moment(task.endsAt).format('YYYY-MM-DD HH:mm')}<br/>${_.escape(where)}<br/>${_.escape(statusPrefix)}: ${_.escape(status)}`;
        },
        taskWorkersContent(task) {
            const ids = task.worker_ids || [];
            const names = ids.map((id) => {
                if (this.workersdict && this.workersdict[id]) return this.workersdict[id].name;
                const fallback = (this.workers || []).find((w) => w.id == id);
                return fallback ? `${fallback.name || ''} ${fallback.surname || ''}`.trim() : '';
            }).filter(Boolean);
            if (names.length > 0) return names.join(', ');
            return this.$t('tasks.unassigned');
        },
        taskRolloverContent(task) {
            const where = task.place != null ? this.taskPlaceLabel(task) : [task.address?.street, task.address?.city].filter(Boolean).join(', ');
            const typeKey = task.kind || task.typeof;
            const kind = this.tasksnames[typeKey] || typeKey || '';
            const status = this.statuseslabels[task.status] || task.status || '';
            const workers = this.taskWorkersContent(task);
            return `<strong>${_.escape(kind)}</strong><br/>${moment(task.startsAt).format('YYYY-MM-DD HH:mm')} - ${moment(task.endsAt).format('YYYY-MM-DD HH:mm')}<br/>${_.escape(this.$t('tasks.list_headers.where'))}: ${_.escape(where)}<br/>${_.escape(this.$t('tasks.list_headers.status'))}: ${_.escape(status)}<br/>${_.escape(this.$t('tasks.list_headers.worker'))}: ${_.escape(workers)}`;
        },
        isTaskFinishedForMap(task) {
            return task && (task.status === 'finished_worker' || task.status === 'cleared');
        },
        taskKindForMap(task) {
            return ((task && (task.kind || task.typeof)) || 'other').toString();
        },
        async geocodeAddress(addressKey, options = {}) {
            if (!addressKey) return null;
            if (this.externalGeoUnavailable) return null;
            if (this.isNominatimCoolingDown()) return null;
            const ignoreCachedNull = !!options.ignoreCachedNull;
            const cacheKey = addressKey.toLowerCase();
            if (Object.prototype.hasOwnProperty.call(this.geocodeCache, cacheKey)) {
                const cachedValue = this.geocodeCache[cacheKey];
                if (cachedValue || !ignoreCachedNull) return cachedValue;
            }
            try {
                const sinceLastRequest = Date.now() - this.geocodeLastRequestAt;
                const delayMs = Math.max(0, 1100 - sinceLastRequest);
                if (delayMs > 0) {
                    await this.wait(delayMs);
                }
                this.geocodeLastRequestAt = Date.now();
                const response = await axios.get('https://nominatim.openstreetmap.org/search', {
                    params: {
                        q: addressKey,
                        format: 'jsonv2',
                        limit: 1,
                        countrycodes: 'pl',
                        addressdetails: 0,
                        'accept-language': 'pl'
                    }
                });
                const best = (response.data || [])[0];
                const point = best ? { lat: parseFloat(best.lat), lng: parseFloat(best.lon) } : null;
                this.geocodeCache[cacheKey] = point;
                localStorage.setItem('tasks_geocode_cache_v1', JSON.stringify(this.geocodeCache));
                return point;
            } catch (error) {
                const statusCode = _.get(error, 'response.status');
                if (statusCode == 429) {
                    this.applyNominatimCooldown(180000);
                } else {
                    if (!statusCode) {
                        this.markExternalGeoUnavailable();
                    }
                    this.geocodeCache[cacheKey] = null;
                    localStorage.setItem('tasks_geocode_cache_v1', JSON.stringify(this.geocodeCache));
                }
                return null;
            }
        },
        async renderTaskMarkers() {
            if (!this.map || !this.L || this.mode !== 'map') return;

            const token = ++this.mapRenderToken;
            this.mapMarkersLoading = true;
            this.clearMapOverlapExpanded();
            this.clearWorkerTimelineLayer();
            try {
                const finishedTaskIcon = this.L.icon({
                    iconUrl: 'https://api.iconify.design/mdi/map-marker-check.svg?color=%232e7d32',
                    iconSize: [34, 34],
                    iconAnchor: [17, 34],
                    popupAnchor: [0, -30]
                });
                const installationMarkerIcon = this.L.divIcon({
                    className: '',
                    html: `<span style="position:relative;display:inline-block;width:34px;height:34px;"><span style="position:absolute;inset:0;background-color:#5d4037;-webkit-mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;"></span><span style="position:absolute;left:50%;top:38%;transform:translate(-50%,-50%);width:12px;height:12px;background-color:#ffffff;-webkit-mask:url('https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/solid/wrench.svg') center / contain no-repeat;mask:url('https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free/svgs/solid/wrench.svg') center / contain no-repeat;"></span></span>`,
                    iconSize: [34, 34],
                    iconAnchor: [17, 34],
                    popupAnchor: [0, -30]
                });
                const inspectionMarkerIcon = this.L.divIcon({
                    className: '',
                    html: `<span style="position:relative;display:inline-block;width:34px;height:34px;"><span style="position:absolute;inset:0;background-color:#1565c0;-webkit-mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;"></span><span style="position:absolute;left:50%;top:38%;transform:translate(-50%,-50%);width:12px;height:12px;background-color:#ffffff;-webkit-mask:url('https://api.iconify.design/mdi/magnify.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/magnify.svg') center / contain no-repeat;"></span></span>`,
                    iconSize: [34, 34],
                    iconAnchor: [17, 34],
                    popupAnchor: [0, -30]
                });
                const kindIcons = {
                    inspection: inspectionMarkerIcon,
                    intervention: this.L.divIcon({
                        className: '',
                        html: `<span style="position:relative;display:inline-block;width:34px;height:34px;"><span style="position:absolute;inset:0;background-color:#ef6c00;-webkit-mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;"></span><span style="position:absolute;left:50%;top:38%;transform:translate(-50%,-50%);width:12px;height:12px;background-color:#ffffff;-webkit-mask:url('https://api.iconify.design/mdi/bug.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/bug.svg') center / contain no-repeat;"></span></span>`,
                        iconSize: [34, 34],
                        iconAnchor: [17, 34],
                        popupAnchor: [0, -30]
                    }),
                    installation: installationMarkerIcon,
                    other: this.L.divIcon({
                        className: '',
                        html: `<span style="position:relative;display:inline-block;width:34px;height:34px;"><span style="position:absolute;inset:0;background-color:#616161;-webkit-mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;mask:url('https://api.iconify.design/mdi/map-marker.svg') center / contain no-repeat;"></span></span>`,
                        iconSize: [34, 34],
                        iconAnchor: [13, 13],
                        popupAnchor: [0, -12]
                    })
                };
                if (!this.taskMarkersLayer || typeof this.taskMarkersLayer.getBounds !== 'function') {
                    if (this.taskMarkersLayer) {
                        this.map.removeLayer(this.taskMarkersLayer);
                    }
                    this.taskMarkersLayer = this.L.featureGroup([]).addTo(this.map);
                }
                this.taskMarkersLayer.clearLayers();

                const groupedByPoint = {};
                const taskPointsById = {};
                const unresolvedEntries = [];
                this.invalidAddressTasksCount = 0;

                for (let index = 0; index < this.listItems.length; index++) {
                    if (token !== this.mapRenderToken) return;
                    const task = this.listItems[index];
                    const hasPlaceField = !!(task && (task.place_id || task.place));
                    let pointSource = 'data';
                    let point = this.taskPointFromData(task);
                    if (!point) {
                        const geocodeCandidates = this.taskGeocodeCandidates(task);
                        for (let candidateIndex = 0; candidateIndex < geocodeCandidates.length; candidateIndex++) {
                            point = await this.geocodeAddress(geocodeCandidates[candidateIndex]);
                            if (point) break;
                        }
                        pointSource = 'geocoded';
                    }
                    if (!point) {
                        unresolvedEntries.push({ task, reason: hasPlaceField ? 'place_invalid' : 'missing_location' });
                        continue;
                    }
                    if (!this.isTaskPointPlausible(task, point, { isGeocoded: pointSource === 'geocoded', hasPlace: hasPlaceField })) {
                        unresolvedEntries.push({ task, reason: hasPlaceField ? 'place_invalid' : 'bad_address' });
                        continue;
                    }
                    taskPointsById[task.id] = point;

                    const markerOptions = { riseOnHover: true };
                    if (this.isTaskFinishedForMap(task)) {
                        markerOptions.icon = finishedTaskIcon;
                    } else {
                        const kindKey = this.taskKindForMap(task);
                        markerOptions.icon = kindIcons[kindKey] || kindIcons.other;
                    }

                    const pointKey = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`;
                    if (!groupedByPoint[pointKey]) {
                        groupedByPoint[pointKey] = {
                            point,
                            items: []
                        };
                    }
                    groupedByPoint[pointKey].items.push({ task, markerOptions });
                }

                const groupedEntries = Object.keys(groupedByPoint).map((key) => groupedByPoint[key]);
                for (let i = 0; i < groupedEntries.length; i++) {
                    const group = groupedEntries[i];
                    const { point, items } = group;

                    if (items.length === 1) {
                        const single = items[0];
                        const taskMarker = this.L.marker([point.lat, point.lng], single.markerOptions);
                        taskMarker.on('mouseover', function() {
                            const el = this.getElement && this.getElement();
                            if (!el) return;
                            el.style.transition = 'transform 120ms ease, filter 120ms ease';
                            const baseTransform = el.dataset.baseTransform || el.style.transform || '';
                            el.dataset.baseTransform = baseTransform;
                            el.style.transform = `${baseTransform} scale(1.12)`;
                            el.style.filter = 'drop-shadow(0 0 6px rgba(0,0,0,0.45))';
                            el.style.cursor = 'pointer';
                            this.setZIndexOffset(1000);
                        });
                        taskMarker.on('mouseout', function() {
                            const el = this.getElement && this.getElement();
                            if (!el) return;
                            el.style.transform = el.dataset.baseTransform || '';
                            el.style.filter = '';
                            el.style.cursor = '';
                            this.setZIndexOffset(0);
                        });
                        taskMarker.on('click', () => this.showTask(single.task));
                        taskMarker.addTo(this.taskMarkersLayer);
                        continue;
                    }

                    const overlapIcon = this.L.divIcon({
                        className: 'tasks-overlap-cluster',
                        html: `<span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:50%;background:linear-gradient(180deg, #42a5f5 0%, #1e88e5 100%);color:#fff;font-weight:700;font-size:13px;line-height:1;box-shadow:0 0 0 3px rgba(255, 255, 255, 0.94), 0 4px 12px rgba(0, 0, 0, 0.38);">${items.length}</span>`,
                        iconSize: [34, 34],
                        iconAnchor: [17, 17]
                    });
                    const overlapMarker = this.L.marker([point.lat, point.lng], {
                        icon: overlapIcon,
                        riseOnHover: true
                    });
                    overlapMarker.on('click', () => {
                        this.expandOverlappingMarkers(group, point);
                    });
                    overlapMarker.addTo(this.taskMarkersLayer);
                }

                this.lastRenderedTaskPointsById = taskPointsById;
                if (this.mapForecastEnabled) {
                    await this.renderWorkerTimelinePaths(taskPointsById);
                } else {
                    this.clearWorkerTimelineLayer();
                }
                this.renderUnresolvedTasksPlaceholder(unresolvedEntries);

                let bounds = null;
                if (typeof this.taskMarkersLayer.getBounds === 'function') {
                    bounds = this.taskMarkersLayer.getBounds();
                } else {
                    const layers = this.taskMarkersLayer.getLayers ? this.taskMarkersLayer.getLayers() : [];
                    if (layers.length > 0) {
                        bounds = this.L.latLngBounds(layers.map((layer) => layer.getLatLng()).filter(Boolean));
                    }
                }

                if (bounds && typeof bounds.isValid === 'function' && bounds.isValid()) {
                    this.map.fitBounds(bounds, { padding: [20, 20] });
                }
            } finally {
                if (token === this.mapRenderToken) {
                    this.mapMarkersLoading = false;
                }
            }
        },
        fetch_places: async function() {
            window.scrollTo(0, 800);
            this.fromload = moment().subtract(1, 'months').startOf('month').unix();
            this.toload = moment().add(1, 'months').endOf('month').unix();
            var response = await axios.get('/customers.json')
            this.customers = response.data;
            for (var i in this.customers) {
                var customer = this.customers[i];
                customer.name = customer.name?.trim() ? customer.name.trim() : customer.short_name;
                for (var j in customer.places) {
                    var place = customer.places[j];
                    place.name = (place.name?.trim() ? place.name.trim() : place.displayedname || "") || "";
                    this.placesdict[place.id] = place.name?.trim() ? place.name.trim() : place.displayedname;
                    this.placeAddressDict[place.id] = place.address || place;
                }
            }
            var response = await axios.get('/tasks/' + this.fromload + '/' + this.toload + '.json')
            this.tasks = response.data;
            for (var i in this.tasks) {
                var task = this.tasks[i];
                task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm');
                task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm');
                task.place_name = ""
                if(task.place != null){
                    task.place_name = "" + task.place.name
                } 
                if(task.address != null){
                    task.place_name = "" + task.address.street + task.address.city
                }
            }
            this.lastLoad = _.now()
            this.loaded = true;
            response = await axios.get('/workers.json')
            this.workers = response.data;
            this.workersdict = {};
            var fromCookies2 = this.$cookies.get('orderedworkers') || "[]";
            var mem = JSON.parse(fromCookies2);
            if (mem.length > 0) {
                this.workers = this.workers.filter(function(worker) { return worker.active }).sort(function(a, b) {
                    return mem.indexOf(a.id) - mem.indexOf(b.id);
                })
            }
            var emptyworkers = this.selectedWorkers.length == 0;
            for (var i in this.workers) {
                var item = this.workers[i];
                if (item.active == true) {
                    this.workerItems.push({ value: item.id, name: item.name + " " + item.surname, symbol: item.symbol });
                    this.workersdict[item.id] = { value: item.id, name: item.name + " " + item.surname, symbol: item.symbol };
                    if (emptyworkers) {
                        this.selectedWorkers.push(item.id)
                    }
                }
            }
            this.workerItems.push({ value: -1, name: this.$t('tasks.unassigned'), symbol: "." });
            this.workersLoaded = true;
            window.scrollTo(0, 900);
            if(this.mode == 'map') {
                this.renderTaskMarkers();
            }
        },
        reordered(value) {
            this.workerItems = value;
            this.$cookies.set('orderedworkers', JSON.stringify(value.map(worker => worker.value)));
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
         applyChanges: function(){
          this.from = this.tasksTimeRange.startDate;
          this.to = this.tasksTimeRange.endDate;
          this.loadFragmentIfNeeded(moment(this.from), moment(this.to))
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        async loadFragmentIfNeeded(f, t) {
            const newFromTimestamp = t.unix();
            const newToTimestamp = f.unix();
            const intervalKey = `${newFromTimestamp}:${newToTimestamp}`;
            try {
                // Fetch the latest timestamp from last.json
                const timestampResponse = await axios.get(`/tasks/${newFromTimestamp}/${newToTimestamp}/last.json`);
                const latestTimestamp = timestampResponse.data;

                // Check if the interval is already loaded and up-to-date
                if (
                    this.loadedData[intervalKey] &&
                    this.loadedData[intervalKey].lastModified >= latestTimestamp
                ) {
                    this.tasks = this.loadedData[intervalKey].tasks;
                    console.log("Requested interval already loaded with up-to-date data");
                    return;
                }
                var scrollPos = window.scrollY;

                // Fetch the actual data for the interval

                this.loaded = false;
                const dataResponse = await axios.get(`/tasks/${newFromTimestamp}/${newToTimestamp}.json`);
                this.tasks = dataResponse.data;

                // Update the loaded data dictionary with the interval key
                this.loadedData[intervalKey] = { lastModified: latestTimestamp, tasks: this.tasks };

                // Process tasks
               for (var i = 0; i < this.tasks.length; i++) {
                    var task = this.tasks[i];
                    task.place_name = ""
                    if(task.place != null){
                        task.place_name = "" + task.place.name
                    } 
                    if(task.address != null){
                        task.place_name = "" + task.address.street + task.address.city
                    }
                }
                 this.loaded = true;
                 this.lastLoad = _.now()
                     this.$nextTick(() => {
                     window.scrollTo(0, scrollPos == 0 ? 600 : scrollPos);
                });
                if(this.mode == 'map') {
                    this.renderTaskMarkers();
                }
            } catch (error) {
                console.error("Error loading data:", error);
            }
        },


        moveline: function(event) {
            if (this.hover && event.target.tagName == "TH") {
                var rect = event.target.parentElement.parentElement.getBoundingClientRect();
                var x = event.clientX - rect.left; //x position within the element.
                var y = event.clientY - rect.top; //y position within the element.
                this.lineoffset = y;
            }
        },
        monthAgo: function() {
            this.calDate.add(-1, 'months');
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },
        monthLater: function() {
            this.calDate.add(1, 'months');
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.calDate.clone().startOf('month'), this.calDate.clone().endOf('month'));
        },

        selectDay(day) {
            this.updateCurrentDate(day);
            this.tasksTimeRange.startDate = this.currentDate.clone().startOf(this.mode).format("YYYY-MM-DD");
            this.tasksTimeRange.endDate = this.currentDate.clone().endOf(this.mode).format("YYYY-MM-DD");
            this.generateWeeks();
            this.$forceUpdate();
            this.loadFragmentIfNeeded(this.currentDate.clone().startOf('month'), this.currentDate.clone().endOf('month'));
        },
        updateScrollPosition(){
            this.scrollPosition = window.scrollY;
        },
        generateWeeks() {
            var start = this.calDate.clone().startOf('month').startOf('week')
            var end = this.calDate.clone().endOf('month').endOf('week')
            var out = []
            var startWeek = start.week();
            var endWeek = end.week();
            start.add(-1, 'days')
            if (startWeek > endWeek) {
                endWeek = endWeek + moment().weeksInYear()
            }
            for (var week in _.range(0, 6)) {
                out.push([start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone(), start.add(1, 'days').clone()])
            }
            this.weeks = out
        },
        setMode(mode) {
            this.tasksTimeRange.startDate = this.currentDate.clone().startOf(mode != 'list' ? mode : 'month').format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = this.currentDate.clone().endOf(mode != 'list' ? mode : 'month').format("YYYY-MM-DD")
            this.mode = mode
            if(mode == 'map'){
                this.activateMap();
            }
        },
        toggleMapForecast() {
            this.mapForecastEnabled = !this.mapForecastEnabled;
            localStorage.setItem('tasks_map_forecast_enabled', this.mapForecastEnabled ? '1' : '0');
            if (this.mode == 'map' && this.map) {
                if (this.mapForecastEnabled) {
                    const hasCachedPoints = this.lastRenderedTaskPointsById && Object.keys(this.lastRenderedTaskPointsById).length > 0;
                    if (hasCachedPoints) {
                        this.renderWorkerTimelinePaths(this.lastRenderedTaskPointsById);
                    } else {
                        this.renderTaskMarkers();
                    }
                } else {
                    this.clearWorkerTimelineLayer();
                }
            }
        },
        cloneTask(task){
            this.instances[0].close()
            var tsk = _.clone(task)
            delete tsk.id
            tsk.status = "dateset"
            tsk.photos = []
            this.addTask(undefined, tsk)
        },
        addTask(hour, task) {
            var start = moment();
            var startreminder = 15 - (start.minute() % 15);
            var end = moment().add(1, 'hour');
            if(this.mode == "days"){
                start = moment().set({date: this.currentDate.date(), month: this.currentDate.month(), year: this.currentDate.year()});
                startreminder = 15 - (start.minute() % 15);
                end = moment().set({date: this.currentDate.date(), month: this.currentDate.month(), year: this.currentDate.year()}).add(1, 'hour');
            }
            
            if(hour != undefined){
                if(_.isArray(hour)){
                    start.set('hour',hour[0].hour())
                    start.set('minutes', hour[0].minutes());
                    start.set('seconds', 0);
                    end.set('hour',hour[1].hour())
                    end.set('minutes', hour[1].minutes());
                    end.set('seconds', 0);
                    startreminder = 0;
                }else{
                    var tmpHour = moment(hour, 'HH:mm')
                    start.set('hour', tmpHour.hour());
                    start.set('minutes', 0);
                    startreminder = 0;
                    end = start.clone().add(1, 'hour');
                }
            }
            var elems = document.querySelectorAll('#newTaskModal');
            if(task == undefined){
                this.ntask = {
                    name: "",
                    status: 'dateset',
                    routine: false,
                    worker_ids: [],
                    place_id: null,
                    startsAt: start.clone().add(startreminder, 'minutes').format('YYYY-MM-DDTHH:mm'),
                    endsAt: end.clone().add(startreminder, 'minutes').format('YYYY-MM-DDTHH:mm'),
                    phone_number: "",
                    address: {
                        name: "",
                        street: "",
                        city: "",
                        postal_code: ""
                    },
                    payment_method: "cash",
                    net_price: 0,
                    pricing: 0,
                    versions: [],
                    comments: [],
                    typeof: 'intervention',
                    intervention_type_other: "",
                    typeof_other: '',
                    reconescance: "",
                    physical_mount: false,
                    name: "",
                    photos: [],
                    edit: true
                }
            }else{
                this.ntask = task;
                var startOf = moment(this.ntask.startsAt);
                var endOf = moment(this.ntask.endsAt);
                this.ntask.startsAt = moment().set('hour', startOf.hour()).set('minute', startOf.minute()).add(1, 'day').format('YYYY-MM-DDTHH:mm')
                this.ntask.endsAt = moment().set('hour', endOf.hour()).set('minute', endOf.minute()).add(1, 'day').format('YYYY-MM-DDTHH:mm')
                this.ntask.edit = true
            }
          
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
        removedTasks: async function() {
          
            var elems = document.querySelectorAll('#tasksDeletions');
            var instancez = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            instancez[0].open()
            var deletes = await axios.get('/tasks/deletions.json');
            this.deletions = _.orderBy(deletes.data, ['created_at'], ['desc']);
            this.deletedloading = false;
        },
        selectDeleted: function(deleted) {
            deleted.id = undefined;
            this.ntask = deleted;
            this.ntask.startsAt = moment(this.ntask.startsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.endsAt = moment(this.ntask.endsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.phone_number ||= "";
            var elems = document.querySelectorAll('#newTaskModal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
        },
        showTask: async function(task) {
            task.edit = false;
            this.ntask = task;
            this.ntask.startsAt = moment(this.ntask.startsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.endsAt = moment(this.ntask.endsAt).utcOffset(1, true).format('YYYY-MM-DDTHH:mm');
            this.ntask.phone_number ||= "";
            var elems = document.querySelectorAll('#newTaskModal');
            this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, dismissible: false});
            if(!_.isUndefined(this.instances[0])) this.instances[0].open()
            var resp = await axios.get('/tasks/' + task.id + ".json");
            task.comments = resp.data.comments
            task.versions = resp.data.versions
            task.photos = resp.data.photos
            task.status = resp.data.status
            this.ntask = _.clone(task);
            this.ntask.address ||= {
                street: "",
                city: "",
                postal_code: ""
            };
            
        },
        saveTaskClicked: async function(task) {
            console.log("started saving")
            try{
                await this.saveTask(this.ntask);
            }catch(error){
                console.log(error)
            }
            this.$refs.taskform.saving = false;
            if (this.instances != undefined) {
                if(!_.isUndefined(this.instances[0])) this.instances[0].close()
            }
        },
        saveTask: async function(task) {
            if(moment(task.startsAt).isAfter(task.endsAt)){
                return false;
            } 
            const formData = new FormData();
            formData.append('task[startsAt]', moment(task.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[endsAt]', moment(task.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
            formData.append('task[typeof]', task.typeof);
            formData.append('task[payment_method]', task.payment_method || "cash");
            formData.append('task[net_price]', task.net_price);
            formData.append('task[pricing]', task.pricing);
            if (task.routine) formData.append('task[routine]', true);
            formData.append('task[name]', task.name);
            formData.append('task[status]', task.status);
            formData.append('task[reconescance]', task.reconescance);
            formData.append('task[physical_mount]', task.physical_mount);
            formData.append('task[intervention_type_other]', task.intervention_type_other || "");
            formData.append('task[typeof_other]', task.typeof_other);
            if (_.isUndefined(task.worker_ids) == false) {
                for (var index in _.range(0, task.worker_ids.length)) {
                    var worker_id = task.worker_ids[index];
                    if(worker_id != -1){
                        formData.append('task[worker_ids][]', worker_id);
                    }
                }
            }
            if (_.isUndefined(task.photos) == false) {
                for (var index in _.range(0, task.photos.length)) {
                    if(task.photos[index].attachment instanceof File) formData.append('task[media_attributes][' + index + '][image]', task.photos[index].attachment);
                    if (task.photos[index].id) {
                        formData.append('task[media_attributes][' + index + '][id]', task.photos[index].id);
                    }
                    if (task.photos[index].destroy) {
                        formData.append('task[media_attributes][' + index + '][_destroy]', true);
                    }
                }
            }
            if (task.typeof == 'intervention') formData.append('task[intervention_type]', task.intervention_type);
            if(_.isUndefined(task.phone_number) == false){
                formData.append('task[phone_number]', task.phone_number);
            }
            if (task.routine == false && (task.typeof == 'other' || task.typeof == 'intervention')) {
                formData.append('task[address_attributes][name]', task.address.name || "");
                formData.append('task[address_attributes][street]', task.address.street);
                formData.append('task[address_attributes][city]', task.address.city);
                formData.append('task[address_attributes][flatno]', task.address.flatno || "");
                formData.append('task[address_attributes][postal_code]', task.address.postal_code);
                if (Number.isFinite(Number(task.address.lat)) && Number.isFinite(Number(task.address.lng))) {
                    formData.append('task[address_attributes][lat]', task.address.lat);
                    formData.append('task[address_attributes][lng]', task.address.lng);
                    formData.append('task[address_attributes][latitude]', task.address.lat);
                    formData.append('task[address_attributes][longitude]', task.address.lng);
                }
                formData.append('task[place_id]', null);
            } else {
                formData.append('task[place_id]', task.place_id);
            }
            var task_id = task.id;
            if (task_id) {
                try{
                    var response = await axios.put('/tasks/' + task_id + '.json', formData)
                    var task = _.cloneDeep(response.data)
                    var task_index = this.tasks.indexOf(_.find(this.tasks, { id: task_id }));
                    if(task_index > -1) this.tasks.splice(task_index, 1);
                }catch(error){
                }

            } else {
                var response = await axios.post('/tasks.json', formData)
                var task = _.cloneDeep(response.data)
            }
            task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
            task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
            if(this.tasks.indexOf() == -1) this.tasks.push(task)
            if(this.mode == 'map') {
                this.renderTaskMarkers();
            }
        },
        removeTask: async function() {
            var response = await axios.delete('/tasks/' + this.ntask.id + '.json')
            this.tasks.splice(this.tasks.indexOf(_.find(this.tasks, { id: this.ntask.id })), 1)
            if(this.mode == 'map') {
                this.renderTaskMarkers();
            }
            if(!_.isUndefined(this.instances[0])) this.instances[0].close()
        },
        weekAgo() {
            this.selectDay(this.currentDate.clone().add(-1, 'week'));
        },
        weekLater() {
            this.selectDay(this.currentDate.clone().add(1, 'week'));
        },
        dayAgo() {
            this.selectDay(this.currentDate.clone().add(-1, 'day'));
        },
        dayLater() {
            this.selectDay(this.currentDate.clone().add(1, 'day'));
        },
        thisWeek() {
            this.currentDate = moment()
            this.generateWeeks()
        },
        today() {
            this.currentDate = moment()
            localStorage.clear('currentDate')
            this.selectDay(this.currentDate);
            this.generateWeeks()
            this.$forceUpdate();
        },
        getTimeFraction(date) {
            var hh = moment(date).hours();
            var mm = moment(date).minutes();
            return 30 + (((hh * 60.0 + mm) / 60) * (100));
        },
        taskDurationMinutes(task) {
            if (!task) return 0;
            const start = moment(task.startsAt);
            const end = moment(task.endsAt);
            const diff = end.diff(start, 'minutes');
            return Math.max(0, diff);
        },
        formatDurationMinutes(totalMinutes) {
            const mins = Number(totalMinutes);
            if (!Number.isFinite(mins)) return '-';
            if (mins < 60) return `${Math.round(mins)} min`;
            const hours = Math.floor(mins / 60);
            const rest = Math.round(mins % 60);
            return rest > 0 ? `${hours} h ${rest} min` : `${hours} h`;
        },
        estimateCommuteMinutesBetweenTasks(previousTask, currentTask) {
            const from = this.taskPointFromData(previousTask);
            const to = this.taskPointFromData(currentTask);
            return this.estimateCommuteMinutesBetweenPoints(from, to);
        },
        estimateCommuteMinutesBetweenPoints(from, to) {
            if (!from || !to) return null;

            const distanceKm = this.haversineKm(from, to);
            if (!Number.isFinite(distanceKm)) return null;

            // Conservative city estimate: average moving speed + fixed parking/walk buffer.
            const averageSpeedKmh = 30;
            const fixedBufferMinutes = 6;
            const driveMinutes = (distanceKm / averageSpeedKmh) * 60;
            return Math.max(0, Math.round(driveMinutes + fixedBufferMinutes));
        },
        commuteRouteCacheKey(from, to) {
            if (!from || !to) return null;
            const fromLat = Number(from.lat).toFixed(5);
            const fromLng = Number(from.lng).toFixed(5);
            const toLat = Number(to.lat).toFixed(5);
            const toLng = Number(to.lng).toFixed(5);
            return `${fromLat},${fromLng}->${toLat},${toLng}`;
        },
        async osrmRouteDurationMinutes(from, to) {
            const cacheKey = this.commuteRouteCacheKey(from, to);
            if (!cacheKey) return null;

            if (Object.prototype.hasOwnProperty.call(this.commuteRouteCache, cacheKey)) {
                return this.commuteRouteCache[cacheKey];
            }

            try {
                const sinceLastRequest = Date.now() - this.commuteRouteLastRequestAt;
                const delayMs = Math.max(0, 220 - sinceLastRequest);
                if (delayMs > 0) {
                    await this.wait(delayMs);
                }
                this.commuteRouteLastRequestAt = Date.now();

                const fromLng = Number(from.lng).toFixed(6);
                const fromLat = Number(from.lat).toFixed(6);
                const toLng = Number(to.lng).toFixed(6);
                const toLat = Number(to.lat).toFixed(6);
                const url = `https://router.project-osrm.org/route/v1/driving/${fromLng},${fromLat};${toLng},${toLat}`;

                const response = await axios.get(url, {
                    params: {
                        overview: 'full',
                        geometries: 'geojson',
                        alternatives: 'false',
                        steps: 'false'
                    }
                });

                const route = _.get(response, 'data.routes[0]');
                const durationSec = route ? Number(route.duration) : NaN;
                const distanceMeters = route ? Number(route.distance) : NaN;
                const geometryCoords = _.get(route, 'geometry.coordinates', []);
                if (!Number.isFinite(durationSec) || durationSec <= 0) {
                    this.commuteRouteCache[cacheKey] = null;
                    return null;
                }

                const pathLatLngs = Array.isArray(geometryCoords)
                    ? geometryCoords
                        .filter((pair) => Array.isArray(pair) && pair.length >= 2)
                        .map((pair) => [Number(pair[1]), Number(pair[0])])
                        .filter((pair) => Number.isFinite(pair[0]) && Number.isFinite(pair[1]))
                    : [];

                const out = {
                    minutes: Math.max(0, Math.round(durationSec / 60)),
                    distanceKm: Number.isFinite(distanceMeters) ? (distanceMeters / 1000) : null,
                    pathLatLngs,
                    source: 'osrm'
                };
                this.commuteRouteCache[cacheKey] = out;
                return out;
            } catch (error) {
                this.commuteRouteCache[cacheKey] = null;
                return null;
            }
        },
        async estimateCommuteWithFallback(from, to) {
            if (!from || !to) return { minutes: null, distanceKm: null, source: 'none' };

            const routeEstimate = await this.osrmRouteDurationMinutes(from, to);
            if (routeEstimate && Number.isFinite(routeEstimate.minutes)) {
                return routeEstimate;
            }

            const fallbackMinutes = this.estimateCommuteMinutesBetweenPoints(from, to);
            const fallbackDistanceKm = this.haversineKm(from, to);
            return {
                minutes: fallbackMinutes,
                distanceKm: Number.isFinite(fallbackDistanceKm) ? fallbackDistanceKm : null,
                pathLatLngs: [
                    [from.lat, from.lng],
                    [to.lat, to.lng]
                ],
                source: 'haversine'
            };
        },
        timelineStatusFromGapAndCommute(gapMinutes, commuteMinutes) {
            if (!Number.isFinite(gapMinutes)) return 'unknown';
            if (gapMinutes < 0) return 'overlap';
            if (commuteMinutes === null || !Number.isFinite(commuteMinutes)) return 'unknown';
            const slackMinutes = gapMinutes - commuteMinutes;
            if (slackMinutes < 0) return 'not_doable';
            if (slackMinutes <= 10) return 'tight';
            return 'doable';
        },
        timelineStatusLabel(status) {
            if (!status) return 'Brak danych';
            if (status.state == 'unassigned') return 'Brak pracownika';
            if (status.state == 'first') return 'Do zrobienia';
            if (status.state == 'unknown') return 'Brak danych trasy';
            if (status.state == 'overlap') return 'Kolizja czasowa';
            if (status.state == 'doable') return 'Do zrobienia';
            if (status.state == 'tight') return 'Na styk';
            if (status.state == 'not_doable') return 'Niewykonalne';
            return 'Brak danych';
        },
        workerPathColor(workerId) {
            const palette = ['#1565c0', '#ef6c00', '#2e7d32', '#6a1b9a', '#546e7a', '#00838f', '#5d4037', '#283593'];
            const idx = Number(workerId) % palette.length;
            return palette[Math.abs(idx)];
        },
        forecastPathColorByState(state) {
            if (state == 'doable') return '#2e7d32';
            if (state == 'tight' || state == 'unknown') return '#f9a825';
            return '#c62828';
        },
        async renderWorkerTimelinePaths(taskPointsById) {
            if (!this.map || !this.L) return;
            this.clearWorkerTimelineLayer();
            const layer = this.L.featureGroup([]).addTo(this.map);
            this.workerTimelineLayer = layer;

            const tasksByWorker = {};
            for (let i = 0; i < this.listItems.length; i++) {
                const task = this.listItems[i];
                const workerIds = task.worker_ids || [];
                for (let j = 0; j < workerIds.length; j++) {
                    const workerId = workerIds[j];
                    if (!tasksByWorker[workerId]) tasksByWorker[workerId] = [];
                    tasksByWorker[workerId].push(task);
                }
            }

            for (const workerId of Object.keys(tasksByWorker)) {
                const color = this.workerPathColor(workerId);
                const workerLabel = (this.workersdict && this.workersdict[workerId] && this.workersdict[workerId].name) || `Pracownik ${workerId}`;
                const ordered = _.orderBy(tasksByWorker[workerId], [(task) => moment(task.startsAt).valueOf()], ['asc']);
                for (let i = 1; i < ordered.length; i++) {
                    const prevTask = ordered[i - 1];
                    const nextTask = ordered[i];
                    const from = taskPointsById[prevTask.id];
                    const to = taskPointsById[nextTask.id];
                    if (!from || !to) continue;

                    const commuteEstimate = await this.estimateCommuteWithFallback(from, to);
                    const commuteMinutes = commuteEstimate.minutes;
                    const distanceKm = Number.isFinite(commuteEstimate.distanceKm)
                        ? commuteEstimate.distanceKm
                        : this.haversineKm(from, to);
                    const gapMinutes = moment(nextTask.startsAt).diff(moment(prevTask.endsAt), 'minutes');
                    const budgetMinutes = this.taskDurationMinutes(nextTask);
                    const state = this.timelineStatusFromGapAndCommute(gapMinutes, commuteMinutes);
                    const statusLabel = this.timelineStatusLabel({ state });
                    const segmentColor = this.forecastPathColorByState(state);
                    const segmentWeight = 5;
                    const segmentOpacity = 0.95;
                    const segmentDashArray = state == 'doable' ? null : state == 'tight' || state == 'unknown' ? '8,6' : '4,6';
                    const slackMinutes = commuteMinutes === null ? null : gapMinutes - commuteMinutes;
                    const slackLabel = slackMinutes === null
                        ? 'rezerwa: brak danych'
                        : `rezerwa: ${slackMinutes >= 0 ? '+' : ''}${slackMinutes} min`;

                    const tooltipHtml = [
                        `<strong>${_.escape(workerLabel)}</strong>`,
                        `${moment(prevTask.endsAt).format('YYYY-MM-DD HH:mm')} -> ${moment(nextTask.startsAt).format('YYYY-MM-DD HH:mm')}`,
                        `odleglosc: ${Number.isFinite(distanceKm) ? this.formatDistanceKm(distanceKm) : 'brak danych'}`,
                        `dojazd: ${commuteMinutes === null ? 'brak danych' : `~${this.formatDurationMinutes(commuteMinutes)}`}${commuteEstimate.source == 'haversine' ? ' (szacunek)' : ''}`,
                        `budzet zadania: ${this.formatDurationMinutes(budgetMinutes)}`,
                        slackLabel,
                        `status: ${_.escape(statusLabel)}`
                    ].join('<br/>');

                    const routeLatLngs = Array.isArray(commuteEstimate.pathLatLngs) && commuteEstimate.pathLatLngs.length > 1
                        ? commuteEstimate.pathLatLngs
                        : [
                            [from.lat, from.lng],
                            [to.lat, to.lng]
                        ];

                    const segment = this.L.polyline(routeLatLngs, {
                        color: segmentColor,
                        weight: segmentWeight,
                        opacity: segmentOpacity,
                        dashArray: segmentDashArray
                    }).addTo(layer);

                    segment.bindTooltip(tooltipHtml, {
                        direction: 'top',
                        sticky: true,
                        opacity: 0.95
                    });
                }
            }
        },
        initialsById(workers) {
            if (_.keyBy(this.workerItems, 'value')[workers[0]] == undefined) return "."
            return _.keyBy(this.workerItems, 'value')[workers[0]].symbol
        }
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.tasks, this.orderby, this.order),
                function(item) {
                    const range = moment.range(moment(that.tasksTimeRange.startDate).startOf('day'), moment(that.tasksTimeRange.endDate).endOf('day'));
                    const outerRange = moment.range(moment(item.startsAt).startOf('day'), moment(item.endsAt).endOf('day'));
                    var [types, intervention_types]  = _.zip(...that.selections.map(str => str.split(':')))
                    types = _.uniq(types)
                    intervention_types = _.reject(intervention_types, function(element){return element == 'null'})
                    var within_time_range = range.overlaps(outerRange);
                    var in_workers_selected = ( _.intersection( that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0) || (item.worker_ids.length == 0 && that.selectedWorkers.indexOf(-1) > -1) || that.mode != 'list';
                    var in_statuses = ( _.intersection( that.statuses, [item.status]).length > 0 || that.statuses.length == 0);
                    var in_names = ((item.place_name || "").toLowerCase().indexOf((that.place_name || "").toLowerCase()) > -1 || (that.place_name || "").length == 0)
                    var in_kinds = _.includes(types, item.kind) || types.length == 0 
                    var in_task_types = item.kind != 'intervention' || intervention_types.length == 0 || _.includes(intervention_types, item.intervention_type)
                    return within_time_range && in_workers_selected && in_statuses && in_kinds && in_task_types &&
                        in_names
                }
            );
        },
        listAllItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.tasks, this.orderby, this.order),
                function(item) {
                    const range = moment.range(moment(that.tasksTimeRange.startDate).startOf('day'), moment(that.tasksTimeRange.endDate).endOf('day'));
                    const outerRange = moment.range(moment(item.startsAt).startOf('day'), moment(item.endsAt).endOf('day'));
                    var within_time_range = range.overlaps(outerRange);
                    var in_kinds = _.includes(that.typeofs, item.kind) || that.typeofs.length == 0 
                    return within_time_range  && in_kinds
                }
            );
        },
        customers_options() {
            return _.map(this.customers, (customer) => {
                return {
                    name: customer.name,
                    items: _.map(customer.places, (place) => {
                        return { name: place.name, value: place.id };
                    })
                };
            })
        },

        listWeeksItems() {
            var out = [];
            var that = this;
            var sow = this.currentDate.clone().startOf('week');
            var eow = this.currentDate.clone().endOf('week');
            var itms = _.orderBy(this.tasks, 'startsAt', 'asc');
            for (var m = moment(sow); m.isBefore(eow); m.add(1, 'days')) {
                out.push([m.format('dddd, D'),
                    _.filter(
                        itms,
                        function(item) {
                            return moment(item.startsAt).isSame(m, 'day') &&
                                (
                                    _.intersection(that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0
                                ) && (
                                    _.intersection(that.typeofs, [item.kind]).length > 0 || that.typeofs.length == 0
                                )
                        })
                ]);
            }
            return out
        },
        listMonthsItems() {
            var out = {};
            var that = this;
            var sow = this.currentDate.clone().startOf('month').startOf('week');
            var eow = this.currentDate.clone().endOf('month').endOf('week');
            var itms = _.filter(_.orderBy(this.tasks, 'startsAt', 'asc'), function(item) {
                return (_.intersection(that.selectedWorkers, item.worker_ids).length > 0 || that.selectedWorkers.length == 0) &&
                    (
                        _.intersection(that.typeofs, [item.kind]).length > 0 || that.typeofs.length == 0
                    )
            })
            for (var m = moment(sow); m.isBefore(eow); m.add(1, 'days')) {
                out[m.format('DD-MM-YYYY')] = _.filter(
                    itms,
                    function(item) {
                        return moment(item.startsAt).isSame(m, 'day')
                    });
            }
            return out
        },
        listWorkersItems() {
            var out = {};
            for (var task in this.listAllItems) {
                for (var worker in this.listAllItems[task].worker_ids) {
                    if (_.isUndefined(out[this.listAllItems[task].worker_ids[worker]])) {
                        out[this.listAllItems[task].worker_ids[worker]] = [];
                    }
                    out[this.listAllItems[task].worker_ids[worker]].push(this.listAllItems[task])
                }
                if (this.listAllItems[task].worker_ids.length == 0) {

                    if (_.isUndefined(out[this.listAllItems[task].worker_ids['undefined']])) {
                        out[this.listAllItems[task].worker_ids['undefined']] = [];
                    }
                    out[this.listAllItems[task].worker_ids['undefined']].push(this.listAllItems[task])
                }
            }
            for (var i = _.keys(out).length - 1; i >= 0; i--) {
                out[_.keys(out)[i]] = _.sortBy(out[_.keys(out)[i]], [function(o) { return moment(o.startsAt).unix(); }])
            }
            return out;
        },
        delayedListWorkersItems(){
            var out = {};
            for (var task in this.tasks) {
                for (var worker in this.tasks[task].worker_ids) {
                    if (_.isUndefined(out[this.tasks[task].worker_ids[worker]])) {
                        out[this.tasks[task].worker_ids[worker]] = [];
                    }
                    if(this.tasks[task].status != 'finished_worker' && this.tasks[task].status != 'finished' && this.tasks[task].status != 'cleared') out[this.tasks[task].worker_ids[worker]].push(this.tasks[task])
                }
            }
            for (var i = _.keys(out).length - 1; i >= 0; i--) {
                out[_.keys(out)[i]] = _.sortBy(out[_.keys(out)[i]], [function(o) { return moment(o.startsAt).unix(); }])
            }
            return out;
        }

    },
    watch: {
        company_address: {
            deep: true,
            handler() {
                this.companyGeocodePoint = null;
                this.companyGeocodeLookupDone = false;
                this.companyGeocodeLastAttemptAt = 0;
            }
        },
        listItems: function() {
            if (this.mode == 'map') {
                this.renderTaskMarkers();
            }
        },
        rangeSelected: function (val) {
          if(val == "currentMonth"){
            this.lastRange = val;
            this.from = moment().startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().startOf("month").format("YYYY-MM-DD")
            this.to = moment().endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("month").format("YYYY-MM-DD")
          }else if(val == "prevMonth"){
            this.lastRange = val;
            this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
            this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
          }else if(val == "lastThreeMonths"){
            this.lastRange = val;
            this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
            this.to = moment().endOf("month").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("month").format("YYYY-MM-DD")
          }else if(val == "currentYear"){
            this.lastRange = val;
            this.from = moment().startOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().startOf("year").format("YYYY-MM-DD")
            this.to = moment().endOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().endOf("year").format("YYYY-MM-DD")
          }else if(val == "prevYear"){
            this.lastRange = val;
            this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.startDate = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
            this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
            this.tasksTimeRange.endDate = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
          }
          this.loadFragmentIfNeeded(moment(this.tasksTimeRange.startDate, 'YYYY-MM-DD').startOf('month'), moment(this.tasksTimeRange.endDate, 'YYYY-MM-DD').endOf('month'));
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.login_button {
    color: red;
}

p.cursor-pointer {
  font-size: 1em;
  margin: 0;
}
thead {
    font-size: 15px;
}

thead th {
    font-weight: 300;

}

table thead th:first-child {
    position: sticky;
    z-index: 2;
}

table>tr>td {

    padding-bottom: 5px;
}

thead>tr>td {
    padding-top: 5px;
}

.btn {
    color: black;
}

.btn.grey {
    background-color: #DADADA !important;
}

thead .input-field {
    margin-top: unset;
    padding-top: 5px;
    margin-bottom: unset;
}

.maincontainer {
    margin: 0px;
}

.calendartable td {
    padding: 0px 3px;
    font-size: 12px;
    text-align: center;
}

.calendartable tr {
    border-bottom: 0px;
}

.calendartable .red {
    background-color: #bbb;
    border-radius: 50%;
    text-align: center;
}

.calendartable .small {
    font-size: 2em;
}


.btn-add {
    border-radius: 8px;
    margin-top: 16px;
}

.task {
    position: absolute;
    max-width: 200px;
    width: 200px;
}

.intervention {
    background-color: rgba(244, 60, 250, 0.25);
}

.inspection {
    background-color: rgba(250, 244, 60, 0.25);
}

.installation {
    background-color: rgba(66, 250, 60, 0.25);
}

.other {
    background-color: rgba(60, 117, 250, 0.25);
}

.intervention,
.inspection,
.installation,
.other {
    padding: 5px;
}

th {
    position: sticky;
}

.circle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    line-height: 30px;
    background-color: #DADADA;
    text-align: center;
    display: inline-block;
}
.label {
    line-height: 2;
}
p {
    font-size: 10px;
    line-height: 2em;
}

.inspection {

    background-color: rgba(250, 244, 60, 0.25);
    font-size: medium;
}

.intervention {

    background-color: rgba(244, 60, 250, 0.25);
    font-size: medium;
}

/*.installation {

  background-color: rgba(60, 117, 250, 0.25);
  font-size: medium;
}*/
.week {
    width: calc(1 / 7 * 100%);

}

.tasks-map-wrap {
    margin-top: 350px;
    height: calc(100vh - 350px);
    position: relative;
}

.tasks-map-forecast-btn {
    position: absolute;
    top: 12px;
    left: 76px;
    z-index: 1200;
}

.tasks-map {
    height: 100%;
}

.tasks-map-loading-overlay {
    position: absolute;
    inset: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.72);
    backdrop-filter: blur(1px);
    pointer-events: none;
}

.tasks-map-loading-text {
    font-size: 13px;
    font-weight: 600;
    color: #2c2c2c;
    background: rgba(255, 255, 255, 0.92);
    padding: 8px 14px;
    border-radius: 999px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}

.task-map-status-icon-wrap {
    background: transparent;
    border: 0;
}

.task-map-status-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #2e7d32;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9), 0 2px 8px rgba(0, 0, 0, 0.35);
}

.tasks-map-search {
    position: absolute;
    top: 12px;
    right: 12px;
    width: min(440px, calc(100% - 24px));
    z-index: 1200;
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.18);
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
    padding: 8px;
}

.tasks-map-search-input-wrap {
    position: relative;
}

.tasks-map-search-input {
    width: 100%;
    height: 40px;
    border: 1px solid #8f8f8f;
    border-radius: 8px;
    padding: 0 36px 0 12px;
    background-color: #ffffff !important;
    color: #111111 !important;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12);
}

.tasks-map-search-input::placeholder {
    color: #666666;
    opacity: 1;
}

.tasks-map-search-clear {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: transparent;
    color: #7a7a7a;
    font-size: 20px;
    line-height: 1;
    padding: 0 4px;
    cursor: pointer;
}

.tasks-map-search-clear:hover {
    color: #222;
}

.tasks-map-search-loading {
    margin-top: 4px;
    padding: 6px 10px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 12px;
}

.tasks-map-search-warning {
    background-color: #fff3e0;
    color: #8a4b08;
    border-left: 3px solid #ef6c00;
}

.tasks-map-search-results {
    margin-top: 6px;
    max-height: 280px;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.tasks-map-search-item {
    padding: 10px 12px;
    font-size: 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
}

.tasks-map-search-item:hover {
    background-color: #f5f7fa;
}

.tasks-map-search-distance {
    margin-top: 3px;
    font-size: 11px;
    color: #6b6b6b;
}

.tasks-map-unresolved-list {
    margin-top: 6px;
    max-height: 260px;
    overflow-y: auto;
    background-color: #fff8e1;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    padding: 8px;
}

.tasks-map-unresolved-list-header {
    font-size: 12px;
    font-weight: 700;
    color: #6b4e00;
    margin-bottom: 6px;
}

.tasks-map-unresolved-item {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.tasks-map-unresolved-item:first-of-type {
    border-top: 0;
    padding-top: 0;
}

.tasks-map-unresolved-item-main {
    flex: 1 1 auto;
    min-width: 0;
}

.tasks-map-unresolved-item-title {
    font-size: 12px;
    font-weight: 600;
    color: #232323;
    word-break: break-word;
}

.tasks-map-unresolved-item-meta {
    margin-top: 2px;
    font-size: 11px;
    color: #7c5a00;
}

.tasks-map-unresolved-item-actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 0 0 120px;
}

.tasks-map-unresolved-action {
    height: 30px;
    line-height: 30px;
    padding: 0 8px;
    font-size: 11px;
    border-radius: 6px;
}

.tasks-overlap-cluster {
    background: transparent;
    border: 0;
}

.tasks-overlap-cluster-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: linear-gradient(180deg, #42a5f5 0%, #1e88e5 100%);
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    line-height: 1;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.94), 0 4px 12px rgba(0, 0, 0, 0.38);
}

.tasks-unresolved-cluster {
    background: transparent;
    border: 0;
}

.tasks-unresolved-cluster span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #9e9e9e;
    color: #fff;
    font-weight: 700;
    font-size: 18px;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.92), 0 3px 10px rgba(0, 0, 0, 0.35);
}

.tasks-unresolved-cluster small {
    position: absolute;
    right: -2px;
    bottom: -2px;
    min-width: 17px;
    height: 17px;
    border-radius: 10px;
    background: #424242;
    color: #fff;
    font-size: 10px;
    line-height: 17px;
    text-align: center;
    padding: 0 4px;
}

.daycolumn {
    width: calc(1 / 7 * 100%);
}

.cell {
    border: 1px solid;
    height: 200px;
    vertical-align: baseline;
}

.tasklist {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(5, 25px);
    grid-row-start: -1;
}

.tasklist>div {
    height: 25px;
}

.upper {
    text-transform: uppercase;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 5px;
    font-size: 12px;
}

.upper .circle {
    font-size: 15px;
}

.rightalign {
    text-align: end;
}

.workerheader-open>div {
    width: 200px;
}

.workerheader-closed>div {
    width: 23px;
}

/deep/ .collapsible-header {
    background-color: gray;
}

.collapsible i {
    right: 54%;
}

.hourtable th:first-child {
    padding-left: 16px;
}

/deep/ .dropdown-content {
    z-index: 102;
}

/deep/ .timepicker-modal {
    width: 75% !important;
}

/deep/ .timepicker-digital-display {
    background-color: #c22026 !important;
}

/deep/ .timepicker-canvas-bg {
    fill: #c22026 !important;
}

/deep/ .timepicker-canvas line {
    stroke: #c22026 !important;
}

/deep/ .timepicker-canvas-bearing {
    fill: #c22026 !important;
}

/deep/ .timepicker-tick:hover {
    background: #c22026 !important;
}

/deep/ .timepicker-close {
    color: #c22026 !important;
}

/deep/ ul#dropdownselectorplace {
    padding: 5px;
}

/deep/ ul#dropdownselectorplace label {
    color: black !important;
    font-size: 10px;
}

.task hr {
    margin: 0px !important;
    border-bottom-width: 0px;
    border-color: black;
}
/deep/ .taskfinished {
    text-decoration: line-through;
}
/deep/ label {
    color: black;
}
tr th {
    vertical-align: baseline;
}
.vue-daterange-picker {
    width: 100%;
    border-radius: 5px;
    height: 35px;
}
/deep/ select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    height: 37px;
}
.deletesmodal{
    top: 2% !important;
    max-height: 100%;
    background-color: #dadada;
}
/deep/ .intervention {
    background-color: rgba(244, 60, 250, 0.25);
}

/deep/ .inspection {
    background-color: rgba(250, 244, 60, 0.25);
}

/deep/ .installation {
    background-color: rgba(66, 250, 60, 0.25);
}

/deep/ .other {
    background-color: rgba(60, 117, 250, 0.25);
}
</style>
